<template>
  <div class="home-container">
    <!-- Cabeçalho fixo com filtros -->
    <div class="header-section">
      <v-container fluid class="pa-4">
        <v-card class="modern-card" elevation="8">
          <v-card-title class="modern-card-title">
            <!-- Primeira linha: Filtros principais -->
            <v-row align="center">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar host"
                  single-line
                  hide-details
                  clearable
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              
              <!-- Novos filtros -->
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="filtroSistemas"
                  :items="sistemasParaFiltro"
                  label="Filtrar por sistema"
                  multiple
                  small-chips
                  clearable
                  outlined
                  dense
                  hide-details
                  style="min-width: 200px; max-width: 200px;"
                  class="fixed-width-select"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0" small>
                      <span>{{ item }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">
                      (+{{ filtroSistemas.length - 1 }} outros)
                    </span>
                  </template>
                </v-select>
              </v-col>
              
              <v-col cols="12" sm="6" md="2">
                <v-select
                  v-model="filtroStatusAtualizacao"
                  :items="statusAtualizacaoOptions"
                  label="Status"
                  clearable
                  outlined
                  dense
                  hide-details
                  style="min-width: 150px; max-width: 150px;"
                  class="fixed-width-select"
                ></v-select>
              </v-col>
              
              <v-col cols="12" sm="6" md="auto" class="mr-4 macro-master-filter-col">
                <div class="d-flex align-center macro-master-filter-wrapper">
                  <v-select
                    v-model="filtroMacroMaster"
                    :items="[
                      { text: 'Contém', value: 'com' },
                      { text: 'Atualizado', value: 'atualizado' },
                      { text: 'Desatualizado', value: 'desatualizado' },
                      { text: 'Não contém', value: 'sem' }
                    ]"
                    label="MacroMaster"
                    item-text="text"
                    item-value="value"
                    clearable
                    outlined
                    dense
                    hide-details
                    class="fixed-width-select macro-master-select"
                  ></v-select>
                  <v-chip
                    v-if="macroMasterVersionFormatted"
                    color="success"
                    text-color="white"
                    class="ml-2 font-weight-medium macro-master-version-chip"
                  >
                    {{ macroMasterVersionFormatted }}
                  </v-chip>
                  <v-btn
                    v-if="macroMasterVersionFormatted"
                    color="primary"
                    small
                    class="ml-2"
                    @click="aplicarFiltros"
                    :loading="aplicandoFiltros"
                  >
                    Aplicar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            
            <!-- Segunda linha: Controles adicionais e badge de filtros ativos -->
            <v-row align="center" class="mt-2">
              <!-- Filtro de Base (GB) -->
              <v-col cols="12" sm="6" md="4" class="base-size-filter-col">
                <div class="base-size-filter-modern">
                  <div class="filter-body-modern">
                    <div class="number-input-modern">
                      <input
                        v-model.number="filtros.baseSizeMin"
                        type="number"
                        :min="baseSizeRange.min"
                        :max="baseSizeRange.max"
                        :step="0.1"
                        :placeholder="baseSizeRange.min.toString()"
                        @change="updateSliderFromInput"
                        class="number-input-field"
                      />
                      <span class="suffix-modern">GB</span>
                    </div>

                    <div class="slider-wrapper-modern">
                      <div class="slider-track-modern"></div>
                      <div 
                        class="slider-range-modern" 
                        :style="getSliderRangeStyle()"
                      ></div>
                      <v-range-slider
                        v-model="baseSizeSliderValue"
                        :min="baseSizeRange.min"
                        :max="baseSizeRange.max"
                        :step="0.1"
                        hide-details
                        class="custom-range-slider"
                        @input="updateBaseSizeFiltersRealTime"
                        @change="updateBaseSizeFilters"
                        @start="onSliderStart"
                        @end="onSliderEnd"
                      ></v-range-slider>
                    </div>

                    <div class="number-input-modern">
                      <input
                        v-model.number="filtros.baseSizeMax"
                        type="number"
                        :min="baseSizeRange.min"
                        :max="baseSizeRange.max"
                        :step="0.1"
                        :placeholder="baseSizeRange.max.toString()"
                        @change="updateSliderFromInput"
                        class="number-input-field"
                      />
                      <span class="suffix-modern">GB</span>
                    </div>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" sm="6" md="2" class="cronograma-filter-col">
                <v-select
                  v-model="filtroCronograma"
                  :items="[{ text: 'Contém', value: 'com' }, { text: 'Não Contém', value: 'sem' }]"
                  label="Cronograma"
                  item-text="text"
                  item-value="value"
                  clearable
                  outlined
                  dense
                  hide-details
                  style="min-width: 150px; max-width: 150px;"
                  class="fixed-width-select"
                ></v-select>
              </v-col>
              
              <v-col cols="auto" class="filter-spacing">
                <v-btn color="primary" @click="syncHosts" :loading="isSyncing" :disabled="isSyncing">
                  <v-icon left>mdi-sync</v-icon>
                  Sincronizar com Zabbix
                </v-btn>
              </v-col>
              
              <v-col cols="auto" class="filter-spacing">
                <v-btn
                  small
                  outlined
                  color="grey"
                  @click="limparFiltros"
                  :disabled="!temFiltrosAtivos"
                >
                  <v-icon left small>mdi-filter-remove</v-icon>
                  Limpar Filtros
                  <v-chip v-if="numeroFiltrosAtivos > 0" small color="primary" text-color="white" class="ml-2">
                    {{ numeroFiltrosAtivos }}
                  </v-chip>
                </v-btn>
              </v-col>
              
              <v-col cols="auto" class="filter-spacing d-flex align-center">
                <v-switch
                  v-model="mostrarTodosHosts"
                  label="Mostrar todos os hosts"
                  dense
                  hide-details
                  @change="filtrarHosts"
                  class="switch-aligned"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-container>
    </div>

    <!-- Área de conteúdo com scroll -->
    <div class="content-section">
      <v-container fluid class="pa-4">
        <v-card class="modern-card" elevation="8">
          <v-data-table
            :headers="headers"
            :items="filteredHosts"
            :search="''"
            :loading="loading || pagination.loadingMore"
            :items-per-page="pagination.itemsPerPage === -1 ? -1 : pagination.itemsPerPage"
            :items-per-page-options="pagination.pageOptions"
            :page="pagination.page"
            :server-items-length="pagination.itemsPerPage === -1 ? -1 : pagination.serverItemsLength"
            :hide-default-footer="false"
            @update:page="onPageChange"
            @update:items-per-page="onItemsPerPageChange"
            class="modern-table scrollable-table"
            :class="{ 'table-dark': $vuetify.theme.dark }"
            ref="dataTable"
          >
              <template v-slot:item.name="{ item }">
                <div class="d-flex align-center">
                  <span>{{ item.name }}</span>
                  <v-btn icon small class="ml-2" :loading="item.syncing" @click="syncSingleHost(item)">
                    <v-icon>mdi-sync</v-icon>
                  </v-btn>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        icon 
                        small 
                        class="ml-1" 
                        color="info"
                        @click="openLogsDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-file-document-multiple</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver logs de cronograma</span>
                  </v-tooltip>
                </div>
              </template>
              
              <template v-slot:item.hostId="{ item }">
                <v-chip small outlined color="primary" class="font-weight-medium">
                  {{ item.hostId }}
                </v-chip>
              </template>
              <template v-slot:item.sistemas="{ item }">
                <div class="d-flex flex-wrap align-center sistemas-grid">
                  <div
                    v-for="sistema in sistemasParaFiltro"
                    :key="`sistema-${sistema}`"
                    class="system-icon-container mr-2 mb-1"
                    :class="getSystemContainerClasses(item, sistema)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <img
                          :src="getIconeSistema(sistema)"
                          :alt="sistema"
                          class="sistema-icon"
                          :title="sistema"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <span v-if="hasSystem(item, sistema)">
                        <strong>{{ sistema }}</strong><br>
                        Versão atual: {{ getSystemVersion(item, sistema) || 'N/A' }}<br>
                        <span v-if="!isSystemUpdated(getSystemVersion(item, sistema), sistema)">
                          Versão atualizada: {{ latestVersions[sistema] }}<br>
                        </span>
                        Base de dados: {{ formatDatabaseSize(getSystemSize(item, sistema)) }}<br>
                        Status: {{ isSystemUpdated(getSystemVersion(item, sistema), sistema) ? '✅ Atualizado' : '❌ Desatualizado' }}<br>
                        <span v-if="isDatabaseSizeBlockedForItem(item, sistema)">
                          <strong>⚠️ Atualização manual bloqueada</strong>
                        </span>
                        <span v-else>
                          <strong>✅ Atualização manual permitida</strong>
                        </span>
                      </span>
                      <span v-else>
                        <strong>{{ sistema }}</strong><br>
                        Host sem este sistema.
                      </span>
                    </v-tooltip>
                  </div>
                </div>
              </template>

              <template v-slot:item.cronograma="{ item }">
                <div class="d-flex justify-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        :color="item.tem_cronograma === true || item.tem_cronograma === 'true' ? 'success' : 'error'"
                      >
                        mdi-clock-outline
                      </v-icon>
                    </template>
                    <span>{{ item.tem_cronograma === true || item.tem_cronograma === 'true' ? 'Possui cronograma' : 'Não possui cronograma' }}</span>
                  </v-tooltip>
                </div>
              </template>
              
              <template v-slot:item.macromaster="{ item }">
                <div class="d-flex align-center">
                  <v-chip
                    v-if="item.macromasterVersion"
                    small
                    :color="getMacroMasterChipColor(item.macromasterVersion)"
                    text-color="white"
                    class="font-weight-medium"
                  >
                    {{ formatMacroMasterHash(item.macromasterVersion) }}
                  </v-chip>
                  <span v-else class="text-caption grey--text">
                    Cliente sem MacroMaster
                  </span>
                </div>
              </template>
              
              <template v-slot:item.actions="{ item }">
                <v-btn small color="primary" @click="openUnifiedDialog(item)">
                  <v-icon left>mdi-view-dashboard</v-icon>
                  Gerenciar Atualizações
                </v-btn>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-card flat>
                    <v-card-text>
                      <host-list-item 
                        :host="item" 
                        :systemVersions="latestVersions"
                      />
                      <div class="mt-2 text-caption">
                        Últimas versões disponíveis: 
                        <span v-if="latestVersions.VCON">VCON: {{ latestVersions.VCON }}</span>
                        <span v-if="latestVersions.VPRA">| VPRA: {{ latestVersions.VPRA }}</span>
                        <span v-if="latestVersions.VSUC">| VSUC: {{ latestVersions.VSUC }}</span>
                        <span v-if="latestVersions.VSUP">| VSUP: {{ latestVersions.VSUP }}</span>
                        <span v-if="latestVersions.VSYN">| VSYN: {{ latestVersions.VSYN }}</span>
                      </div>
                    </v-card-text>
                  </v-card>
                </td>
              </template>
              
              <!-- Loading footer para scroll infinito -->
              <template v-slot:body.append>
                <tr v-if="showAllMode && !allHostsLoaded" class="loading-row" :class="{ 'loading-active': pagination.loadingMore }">
                  <td :colspan="headers.length">
                    <div class="loader-container">
                      <div class="spinner" :class="{ 'spinner-active': pagination.loadingMore }"></div>
                      <span>{{ pagination.loadingMore ? 'Carregando mais hosts...' : 'Role para carregar mais hosts' }}</span>
                    </div>
                  </td>
                </tr>
              </template>
          </v-data-table>
        </v-card>
      </v-container>
    </div>

    <!-- Dialog Unificado para Ações -->
    <UnifiedActionDialog
      v-model="unifiedDialog"
      :selected-host="selectedHost"
      :latest-versions="latestVersions"
      :atualizando="atualizando"
      @atualizar-sistema="atualizarSistema"
      @show-snackbar="showSnackbar"
      @refresh-data="syncSingleHost(selectedHost)"
    />

    <!-- Dialog para configurar cronograma -->
    <CronogramaConfig
      v-model="cronogramaDialog"
      :selected-host="selectedHost"
      :cronograma-data="cronogramaDataCompleto"
      :loading="salvandoCronograma"
      @save="saveCronograma"
      @cancel="cronogramaDialog = false"
      @bloqueado="(mensagem) => showSnackbar(mensagem, 'error')"
    />

    <!-- Dialog para atualização manual -->
    <v-dialog v-model="atualizacaoDialog" :max-width="dialogWidth" class="modern-dialog">
      <v-card class="modern-dialog-card">
        <v-card-title>
          Atualização Manual
          <v-spacer></v-spacer>
          <span class="subtitle-1">{{ selectedHost ? selectedHost.name : '' }}</span>
        </v-card-title>
        <v-card-text class="px-8 py-6">
          <div v-if="selectedHost && (selectedHost.hasVCON || selectedHost.hasVPRA || selectedHost.hasVSUC || selectedHost.hasVSUP || selectedHost.hasVSYN)" class="d-flex justify-space-around align-center">
            <!-- VCON -->
            <div v-if="selectedHost && selectedHost.hasVCON" class="system-update-container flex-shrink-0 mx-2">
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'updated': isAtualizado('VCON'), 'outdated': !isAtualizado('VCON') }"
                >
                  <img 
                    :src="getIconeSistema('VCON')" 
                    :alt="'VCON'"
                    class="sistema-icon-large"
                    :title="'VCON'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VCON</strong>
                  <div class="caption grey--text">
                    {{ selectedHost.vconVersion || 'N/A' }}
                  </div>
                  <div class="caption" :class="isAtualizado('VCON') ? 'success--text' : 'warning--text'">
                    {{ isAtualizado('VCON') ? 'Atualizado' : 'Desatualizado' }}
                  </div>
                  <div v-if="isDatabaseSizeBlocked('VCON')" class="caption error--text">
                    <v-icon small color="error">mdi-lock</v-icon>
                    Base dados: {{ formatDatabaseSize(selectedHost.vconSize) }}
                  </div>
                </div>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    :color="getButtonColor('VCON')" 
                    :loading="atualizando === 'VCON'"
                    :disabled="isButtonDisabled('VCON')"
                    @click="handleButtonClick('VCON')"
                    v-bind="attrs"
                    v-on="on"
                    dark
                    block
                    class="mt-2"
                    style="min-width: 160px; white-space: nowrap;"
                  >
                    <v-icon left>{{ getButtonIcon('VCON') }}</v-icon>
                    {{ getButtonText('VCON') }}
                  </v-btn>
                </template>
                <span v-if="isDatabaseSizeBlocked('VCON')">
                  {{ getUpdateBlockTooltip('VCON') }}
                </span>
                <span v-else-if="isAtualizado('VCON')">
                  Sistema já atualizado. Versão do sistema: {{ selectedHost.vconVersion }} | Versão da SCI: {{ latestVersions.VCON }}
                </span>
                <span v-else>
                  Atualizar para a versão {{ latestVersions.VCON }}
                </span>
              </v-tooltip>
            </div>

            <!-- VPRA -->
            <div v-if="selectedHost && selectedHost.hasVPRA" class="system-update-container flex-shrink-0 mx-2">
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'updated': isAtualizado('VPRA'), 'outdated': !isAtualizado('VPRA') }"
                >
                  <img 
                    :src="getIconeSistema('VPRA')" 
                    :alt="'VPRA'"
                    class="sistema-icon-large"
                    :title="'VPRA'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VPRA</strong>
                  <div class="caption grey--text">
                    {{ selectedHost.vpraVersion || 'N/A' }}
                  </div>
                  <div class="caption" :class="isAtualizado('VPRA') ? 'success--text' : 'warning--text'">
                    {{ isAtualizado('VPRA') ? 'Atualizado' : 'Desatualizado' }}
                  </div>
                  <div v-if="isDatabaseSizeBlocked('VPRA')" class="caption error--text">
                    <v-icon small color="error">mdi-lock</v-icon>
                    Base dados: {{ formatDatabaseSize(selectedHost.vpraSize) }}
                  </div>
                </div>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    :color="getButtonColor('VPRA')" 
                    :loading="atualizando === 'VPRA'"
                    :disabled="isButtonDisabled('VPRA')"
                    @click="handleButtonClick('VPRA')"
                    v-bind="attrs"
                    v-on="on"
                    dark
                    block
                    class="mt-2"
                    style="min-width: 160px; white-space: nowrap;"
                  >
                    <v-icon left>{{ getButtonIcon('VPRA') }}</v-icon>
                    {{ getButtonText('VPRA') }}
                  </v-btn>
                </template>
                <span v-if="isDatabaseSizeBlocked('VPRA')">
                  {{ getUpdateBlockTooltip('VPRA') }}
                </span>
                <span v-else-if="isAtualizado('VPRA')">
                  Sistema já atualizado. Versão do sistema: {{ selectedHost.vpraVersion }} | Versão da SCI: {{ latestVersions.VPRA }}
                </span>
                <span v-else>
                  Atualizar para a versão {{ latestVersions.VPRA }}
                </span>
              </v-tooltip>
            </div>

            <!-- VSUC -->
            <div v-if="selectedHost && selectedHost.hasVSUC" class="system-update-container flex-shrink-0 mx-2">
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'updated': isAtualizado('VSUC'), 'outdated': !isAtualizado('VSUC') }"
                >
                  <img 
                    :src="getIconeSistema('VSUC')" 
                    :alt="'VSUC'"
                    class="sistema-icon-large"
                    :title="'VSUC'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VSUC</strong>
                  <div class="caption grey--text">
                    {{ selectedHost.vsucVersion || 'N/A' }}
                  </div>
                  <div class="caption" :class="isAtualizado('VSUC') ? 'success--text' : 'warning--text'">
                    {{ isAtualizado('VSUC') ? 'Atualizado' : 'Desatualizado' }}
                  </div>
                  <div v-if="isDatabaseSizeBlocked('VSUC')" class="caption error--text">
                    <v-icon small color="error">mdi-lock</v-icon>
                    Base dados: {{ formatDatabaseSize(selectedHost.vsucSize) }}
                  </div>
                </div>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    :color="getButtonColor('VSUC')" 
                    :loading="atualizando === 'VSUC'"
                    :disabled="isButtonDisabled('VSUC')"
                    @click="handleButtonClick('VSUC')"
                    v-bind="attrs"
                    v-on="on"
                    dark
                    block
                    class="mt-2"
                    style="min-width: 160px; white-space: nowrap;"
                  >
                    <v-icon left>{{ getButtonIcon('VSUC') }}</v-icon>
                    {{ getButtonText('VSUC') }}
                  </v-btn>
                </template>
                <span v-if="isDatabaseSizeBlocked('VSUC')">
                  {{ getUpdateBlockTooltip('VSUC') }}
                </span>
                <span v-else-if="isAtualizado('VSUC')">
                  Sistema já atualizado. Versão do sistema: {{ selectedHost.vsucVersion }} | Versão da SCI: {{ latestVersions.VSUC }}
                </span>
                <span v-else>
                  Atualizar para a versão {{ latestVersions.VSUC }}
                </span>
              </v-tooltip>
            </div>

            <!-- VSUP -->
            <div v-if="selectedHost && selectedHost.hasVSUP" class="system-update-container flex-shrink-0 mx-2">
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'updated': isAtualizado('VSUP'), 'outdated': !isAtualizado('VSUP') }"
                >
                  <img 
                    :src="getIconeSistema('VSUP')" 
                    :alt="'VSUP'"
                    class="sistema-icon-large"
                    :title="'VSUP'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VSUP</strong>
                  <div class="caption grey--text">
                    {{ selectedHost.vsupVersion || 'N/A' }}
                  </div>
                  <div class="caption" :class="isAtualizado('VSUP') ? 'success--text' : 'warning--text'">
                    {{ isAtualizado('VSUP') ? 'Atualizado' : 'Desatualizado' }}
                  </div>
                  <div v-if="isDatabaseSizeBlocked('VSUP')" class="caption error--text">
                    <v-icon small color="error">mdi-lock</v-icon>
                    Base dados: {{ formatDatabaseSize(selectedHost.vsupSize) }}
                  </div>
                </div>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    :color="getButtonColor('VSUP')" 
                    :loading="atualizando === 'VSUP'"
                    :disabled="isButtonDisabled('VSUP')"
                    @click="handleButtonClick('VSUP')"
                    v-bind="attrs"
                    v-on="on"
                    dark
                    block
                    class="mt-2"
                    style="min-width: 160px; white-space: nowrap;"
                  >
                    <v-icon left>{{ getButtonIcon('VSUP') }}</v-icon>
                    {{ getButtonText('VSUP') }}
                  </v-btn>
                </template>
                <span v-if="isDatabaseSizeBlocked('VSUP')">
                  {{ getUpdateBlockTooltip('VSUP') }}
                </span>
                <span v-else-if="isAtualizado('VSUP')">
                  Sistema já atualizado. Versão do sistema: {{ selectedHost.vsupVersion }} | Versão da SCI: {{ latestVersions.VSUP }}
                </span>
                <span v-else>
                  Atualizar para a versão {{ latestVersions.VSUP }}
                </span>
              </v-tooltip>
            </div>

            <!-- VSYN -->
            <div v-if="selectedHost && selectedHost.hasVSYN" class="system-update-container flex-shrink-0 mx-2">
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'updated': isAtualizado('VSYN'), 'outdated': !isAtualizado('VSYN') }"
                >
                  <img 
                    :src="getIconeSistema('VSYN')" 
                    :alt="'VSYN'"
                    class="sistema-icon-large"
                    :title="'VSYN'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VSYN</strong>
                  <div class="caption grey--text">
                    {{ selectedHost.vsynVersion || 'N/A' }}
                  </div>
                  <div class="caption" :class="isAtualizado('VSYN') ? 'success--text' : 'warning--text'">
                    {{ isAtualizado('VSYN') ? 'Atualizado' : 'Desatualizado' }}
                  </div>
                  <div v-if="isDatabaseSizeBlocked('VSYN')" class="caption error--text">
                    <v-icon small color="error">mdi-lock</v-icon>
                    Base dados: {{ formatDatabaseSize(selectedHost.vsynSize) }}
                  </div>
                </div>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    :color="getButtonColor('VSYN')" 
                    :loading="atualizando === 'VSYN'"
                    :disabled="isButtonDisabled('VSYN')"
                    @click="handleButtonClick('VSYN')"
                    v-bind="attrs"
                    v-on="on"
                    dark
                    block
                    class="mt-2"
                    style="min-width: 160px; white-space: nowrap;"
                  >
                    <v-icon left>{{ getButtonIcon('VSYN') }}</v-icon>
                    {{ getButtonText('VSYN') }}
                  </v-btn>
                </template>
                <span v-if="isDatabaseSizeBlocked('VSYN')">
                  {{ getUpdateBlockTooltip('VSYN') }}
                </span>
                <span v-else-if="isAtualizado('VSYN')">
                  Sistema já atualizado. Versão do sistema: {{ selectedHost.vsynVersion }} | Versão da SCI: {{ latestVersions.VSYN }}
                </span>
                <span v-else>
                  Atualizar para a versão {{ latestVersions.VSYN }}
                </span>
              </v-tooltip>
            </div>
          </div>

          <!-- Mensagem quando não há sistemas -->
          <div v-if="selectedHost && !selectedHost.hasVCON && !selectedHost.hasVPRA && !selectedHost.hasVSUC && !selectedHost.hasVSUP && !selectedHost.hasVSYN" class="text-center pa-4">
            <v-alert type="info" text>
              Este host não possui nenhum dos sistemas configurados.
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            v-if="atualizando" 
            color="orange darken-1" 
            text 
            @click="limparEstadoAtualizacao"
            class="mr-2"
          >
            <v-icon left>mdi-refresh</v-icon>
            Limpar Estado
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="fecharDialogAtualizacao">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para agendamento manual cronogramado -->
    <v-dialog v-model="manualCronogramadoDialog" :max-width="dialogWidthManualCronogramado" class="modern-dialog">
      <v-card class="modern-dialog-card">
        <v-card-title>
           Agendar Atualização Manual
          <v-spacer></v-spacer>
          <span class="subtitle-1">{{ selectedHost ? selectedHost.name : '' }}</span>
        </v-card-title>
        <v-card-text class="px-8 py-6">
          <div v-if="selectedHost">
            <!-- NOVO: Mensagem de erro quando host não está vinculado ao template 12647 -->
            <v-alert v-if="templateValidationError" type="error" outlined class="mb-4">
              <div class="d-flex align-center">
                <v-icon left color="error">mdi-alert-circle</v-icon>
                <strong>Template de Padronização Não Vinculado</strong>
              </div>
              <div class="mt-2">
                {{ templateValidationError }}
              </div>
              <div v-if="templatesVinculados && templatesVinculados.length > 0" class="mt-3">
                <div><strong>Templates vinculados atualmente:</strong></div>
                <ul class="mt-2">
                  <li v-for="(template, index) in templatesVinculados" :key="index">
                    {{ template.templateid }}: {{ template.name }}
                  </li>
                </ul>
              </div>
              <div class="mt-3">
                <small>
                  <strong>Observação:</strong> É necessário vincular o template "Atualizacao Automatica - Padronizacao" (ID: 12647) ao host para que a atualização manual cronogramada funcione corretamente.
                </small>
              </div>
            </v-alert>

            <!-- Informação sobre agendamentos existentes -->
            <v-alert v-if="agendamentosManuaisExistentes && agendamentosManuaisExistentes.length > 0 && !templateValidationError" type="info" text class="mb-4">
              <div><strong>Agendamentos existentes:</strong></div>
              <div v-for="(agendamento, index) in agendamentosManuaisExistentesOrdenados" :key="index" class="mt-2 d-flex align-center justify-space-between">
                <div>
                  <strong>Sistema:</strong> {{ agendamento.sistema }} | <strong>Horário:</strong> {{ agendamento.horario }} | <strong>Data:</strong> {{ formatarData(agendamento.data) }}
                </div>
                <v-btn
                  icon
                  x-small
                  color="error"
                  @click="removerAgendamentoIndividual(agendamento.sistema)"
                  :loading="removendoAgendamento && sistemaRemovendo === agendamento.sistema"
                  class="ml-2"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-alert>

            <!-- Mensagem quando não há sistemas desatualizados disponíveis para agendamento -->
            <div v-if="sistemasDisponiveisParaAgendamentoManual.length === 0 && (!agendamentosManuaisExistentes || agendamentosManuaisExistentes.length === 0)" class="text-center pa-4">
              <v-alert type="info" text>
                Este host não possui sistemas desatualizados para agendamento.
              </v-alert>
            </div>
            
            <!-- Mensagem quando todos os sistemas desatualizados já têm agendamento -->
            <div v-if="sistemasDisponiveisParaAgendamentoManual.length === 0 && agendamentosManuaisExistentes && agendamentosManuaisExistentes.length > 0" class="text-center pa-4">
              <v-alert type="info" text>
                Todos os sistemas desatualizados já possuem agendamento. Remova um agendamento existente para configurar outro sistema.
              </v-alert>
            </div>

            <!-- Sistemas desatualizados com o mesmo template do Configurar Cronograma -->
            <!-- Só mostrar o formulário se não houver erro de template -->
            <v-form ref="formManualCronogramado" v-model="valid" v-if="sistemasDisponiveisParaAgendamentoManual.length > 0 && !templateValidationError">
              <div class="d-flex justify-space-around align-center">
                <!-- VCON -->
                <div v-if="sistemasDisponiveisParaAgendamentoManual.includes('VCON')" class="system-cronograma-container flex-shrink-0 mx-2">
                  <div class="text-center mb-3">
                    <div
                      class="system-icon-container-large"
                      :class="{ 'active': manualCronogramadoForm.vcon, 'inactive': !manualCronogramadoForm.vcon }"
                    >
                      <img 
                        :src="getIconeSistema('VCON')" 
                        :alt="'VCON'"
                        class="sistema-icon-large"
                        :title="'VCON'"
                      />
                    </div>
                    <div class="mt-2">
                      <strong>VCON</strong>
                      <div class="caption" :class="manualCronogramadoForm.vcon ? 'success--text' : 'grey--text'">
                        {{ manualCronogramadoForm.vcon ? 'Ativo' : 'Inativo' }}
                      </div>
                    </div>
                  </div>
                  <v-checkbox 
                    v-model="manualCronogramadoForm.vcon"
                    :label="'Ativar'"
                    class="mt-2"
                    hide-details
                    @change="onSistemaManualCronogramadoChange('vcon')"
                  ></v-checkbox>
                  <v-text-field
                    v-model="manualCronogramadoForm.horarioVcon"
                    type="time"
                    :disabled="!manualCronogramadoForm.vcon"
                    label="Horário"
                    class="mt-2"
                    hide-details
                    outlined
                    dense
                    mask="##:##"
                    placeholder="HH:MM"
                  ></v-text-field>
                </div>

                <!-- VPRA -->
                <div v-if="sistemasDisponiveisParaAgendamentoManual.includes('VPRA')" class="system-cronograma-container flex-shrink-0 mx-2">
                  <div class="text-center mb-3">
                    <div
                      class="system-icon-container-large"
                      :class="{ 'active': manualCronogramadoForm.vpra, 'inactive': !manualCronogramadoForm.vpra }"
                    >
                      <img 
                        :src="getIconeSistema('VPRA')" 
                        :alt="'VPRA'"
                        class="sistema-icon-large"
                        :title="'VPRA'"
                      />
                    </div>
                    <div class="mt-2">
                      <strong>VPRA</strong>
                      <div class="caption" :class="manualCronogramadoForm.vpra ? 'success--text' : 'grey--text'">
                        {{ manualCronogramadoForm.vpra ? 'Ativo' : 'Inativo' }}
                      </div>
                    </div>
                  </div>
                  <v-checkbox 
                    v-model="manualCronogramadoForm.vpra"
                    :label="'Ativar'"
                    class="mt-2"
                    hide-details
                    @change="onSistemaManualCronogramadoChange('vpra')"
                  ></v-checkbox>
                  <v-text-field
                    v-model="manualCronogramadoForm.horarioVpra"
                    type="time"
                    :disabled="!manualCronogramadoForm.vpra"
                    label="Horário"
                    class="mt-2"
                    hide-details
                    outlined
                    dense
                    mask="##:##"
                    placeholder="HH:MM"
                  ></v-text-field>
                </div>

                <!-- VSUC -->
                <div v-if="sistemasDisponiveisParaAgendamentoManual.includes('VSUC')" class="system-cronograma-container flex-shrink-0 mx-2">
                  <div class="text-center mb-3">
                    <div
                      class="system-icon-container-large"
                      :class="{ 'active': manualCronogramadoForm.vsuc, 'inactive': !manualCronogramadoForm.vsuc }"
                    >
                      <img 
                        :src="getIconeSistema('VSUC')" 
                        :alt="'VSUC'"
                        class="sistema-icon-large"
                        :title="'VSUC'"
                      />
                    </div>
                    <div class="mt-2">
                      <strong>VSUC</strong>
                      <div class="caption" :class="manualCronogramadoForm.vsuc ? 'success--text' : 'grey--text'">
                        {{ manualCronogramadoForm.vsuc ? 'Ativo' : 'Inativo' }}
                      </div>
                    </div>
                  </div>
                  <v-checkbox 
                    v-model="manualCronogramadoForm.vsuc"
                    :label="'Ativar'"
                    class="mt-2"
                    hide-details
                    @change="onSistemaManualCronogramadoChange('vsuc')"
                  ></v-checkbox>
                  <v-text-field
                    v-model="manualCronogramadoForm.horarioVsuc"
                    type="time"
                    :disabled="!manualCronogramadoForm.vsuc"
                    label="Horário"
                    class="mt-2"
                    hide-details
                    outlined
                    dense
                    mask="##:##"
                    placeholder="HH:MM"
                  ></v-text-field>
                </div>

                <!-- VSUP (bloqueado se VSUC < 8.04a) -->
                <div v-if="sistemasDisponiveisParaAgendamentoManual.includes('VSUP')" class="system-cronograma-container flex-shrink-0 mx-2">
                  <div class="text-center mb-3">
                    <div
                      class="system-icon-container-large"
                      :class="{ 'active': manualCronogramadoForm.vsup && podeAtualizarVSUPManual, 'inactive': !manualCronogramadoForm.vsup || !podeAtualizarVSUPManual }"
                    >
                      <img 
                        :src="getIconeSistema('VSUP')" 
                        :alt="'VSUP'"
                        class="sistema-icon-large"
                        :title="podeAtualizarVSUPManual ? 'VSUP' : mensagemBloqueioVSUPManual"
                      />
                    </div>
                    <div class="mt-2">
                      <strong>VSUP</strong>
                      <div v-if="!podeAtualizarVSUPManual" class="caption warning--text">
                        Bloqueado (VSUC &lt; 8.04a)
                      </div>
                      <div v-else class="caption" :class="manualCronogramadoForm.vsup ? 'success--text' : 'grey--text'">
                        {{ manualCronogramadoForm.vsup ? 'Ativo' : 'Inativo' }}
                      </div>
                    </div>
                  </div>
                  <v-tooltip v-if="!podeAtualizarVSUPManual" bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-checkbox 
                          v-model="manualCronogramadoForm.vsup"
                          :label="'Ativar'"
                          class="mt-2"
                          hide-details
                          disabled
                          @change="onSistemaManualCronogramadoChange('vsup')"
                        ></v-checkbox>
                      </span>
                    </template>
                    <span>{{ mensagemBloqueioVSUPManual || 'Atualize o VSUC para 8.04a ou superior antes de agendar o VSUP.' }}</span>
                  </v-tooltip>
                  <v-checkbox 
                    v-else
                    v-model="manualCronogramadoForm.vsup"
                    :label="'Ativar'"
                    class="mt-2"
                    hide-details
                    @change="onSistemaManualCronogramadoChange('vsup')"
                  ></v-checkbox>
                  <v-text-field
                    v-model="manualCronogramadoForm.horarioVsup"
                    type="time"
                    :disabled="!manualCronogramadoForm.vsup || !podeAtualizarVSUPManual"
                    label="Horário"
                    class="mt-2"
                    hide-details
                    outlined
                    dense
                    mask="##:##"
                    placeholder="HH:MM"
                  ></v-text-field>
                </div>

                <!-- VSYN -->
                <div v-if="sistemasDisponiveisParaAgendamentoManual.includes('VSYN')" class="system-cronograma-container flex-shrink-0 mx-2">
                  <div class="text-center mb-3">
                    <div
                      class="system-icon-container-large"
                      :class="{ 'active': manualCronogramadoForm.vsyn, 'inactive': !manualCronogramadoForm.vsyn }"
                    >
                      <img 
                        :src="getIconeSistema('VSYN')" 
                        :alt="'VSYN'"
                        class="sistema-icon-large"
                        :title="'VSYN'"
                      />
                    </div>
                    <div class="mt-2">
                      <strong>VSYN</strong>
                      <div class="caption" :class="manualCronogramadoForm.vsyn ? 'success--text' : 'grey--text'">
                        {{ manualCronogramadoForm.vsyn ? 'Ativo' : 'Inativo' }}
                      </div>
                    </div>
                  </div>
                  <v-checkbox 
                    v-model="manualCronogramadoForm.vsyn"
                    :label="'Ativar'"
                    class="mt-2"
                    hide-details
                    @change="onSistemaManualCronogramadoChange('vsyn')"
                  ></v-checkbox>
                  <v-text-field
                    v-model="manualCronogramadoForm.horarioVsyn"
                    type="time"
                    :disabled="!manualCronogramadoForm.vsyn"
                    label="Horário"
                    class="mt-2"
                    hide-details
                    outlined
                    dense
                    mask="##:##"
                    placeholder="HH:MM"
                  ></v-text-field>
                </div>
              </div>

              <!-- Validação de horários - Avisos dinâmicos -->
              <v-alert v-if="erroHorarioMinimo" type="error" outlined class="mt-3">
                <div class="d-flex align-center">
                  <v-icon left>mdi-alert-circle</v-icon>
                  <strong>Horário Inválido</strong>
                </div>
                <div class="mt-2">
                  {{ erroHorarioMinimo }}
                </div>
              </v-alert>

              <v-alert v-if="erroHorarioMaximo" type="error" outlined class="mt-3">
                <div class="d-flex align-center">
                  <v-icon left>mdi-alert-circle</v-icon>
                  <strong>Horário Inválido</strong>
                </div>
                <div class="mt-2">
                  {{ erroHorarioMaximo }}
                </div>
              </v-alert>

              <v-alert v-if="erroConflito10Minutos" type="error" outlined class="mt-3">
                <div class="d-flex align-center">
                  <v-icon left>mdi-alert-circle</v-icon>
                  <strong>Conflito de Horários Detectado!</strong>
                </div>
                <div class="mt-2">
                  {{ erroConflito10Minutos }}
                </div>
                <div class="mt-2">
                  <small>
                    <strong>Regra:</strong> Deve haver no mínimo 10 minutos entre a execução de sistemas diferentes
                  </small>
                </div>
              </v-alert>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="fecharDialogManualCronogramado">
            Cancelar
          </v-btn>
          <v-btn 
            v-if="sistemasDisponiveisParaAgendamentoManual.length > 0 && !templateValidationError"
            color="primary" 
            @click="salvarAgendamentoManual"
            :loading="salvandoAgendamento"
            :disabled="temConflitosHorarioManual || !temSistemasAgendados"
          >
            <v-icon left>mdi-calendar-clock</v-icon>
            Agendar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para configurações de porta -->
    <v-dialog v-model="portaConfigDialog" max-width="500px" class="modern-dialog">
      <v-card class="modern-dialog-card">
        <v-card-title>
          <v-icon left>mdi-cog</v-icon>
          Configurações de Porta
          <v-spacer></v-spacer>
          <span class="subtitle-1">{{ selectedHost ? selectedHost.name : '' }}</span>
        </v-card-title>
        <v-card-text class="px-8 py-6">
          <div v-if="selectedHost">
            <v-switch
              v-model="portaConfigForm.porta_bloqueio"
              label="Porta Bloqueada"
              color="error"
              hide-details
              class="mb-4"
            >
              <template v-slot:label>
                <span class="font-weight-medium">Porta Bloqueada</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                  </template>
                  <span>Quando ativado, bloqueia a configuração de cronograma para este host</span>
                </v-tooltip>
              </template>
            </v-switch>

            <v-switch
              v-model="portaConfigForm.porta_liberado"
              label="Porta Liberada"
              color="success"
              hide-details
              :disabled="!portaConfigForm.porta_bloqueio"
              class="mb-4"
            >
              <template v-slot:label>
                <span class="font-weight-medium">Porta Liberada</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                  </template>
                  <span>Quando a porta está bloqueada, ative esta opção para permitir a configuração de cronograma</span>
                </v-tooltip>
              </template>
            </v-switch>

            <v-alert v-if="portaConfigForm.porta_bloqueio && !portaConfigForm.porta_liberado" type="warning" outlined class="mt-4">
              <div class="d-flex align-center">
                <v-icon left>mdi-alert</v-icon>
                <span>Com a porta bloqueada e não liberada, não será possível configurar cronogramas para este host.</span>
              </div>
            </v-alert>

            <v-alert v-if="portaConfigForm.porta_bloqueio && portaConfigForm.porta_liberado" type="info" outlined class="mt-4">
              <div class="d-flex align-center">
                <v-icon left>mdi-information</v-icon>
                <span>A porta está bloqueada, mas liberada. É possível configurar cronogramas normalmente.</span>
              </div>
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="fecharPortaConfigDialog">
            Cancelar
          </v-btn>
          <v-btn 
            color="primary" 
            @click="salvarPortaConfig"
            :loading="salvandoPortaConfig"
          >
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- LogViewer -->
    <log-viewer
      v-model="logsDialog"
      :selected-host="selectedHost"
      @show-snackbar="showSnackbar"
      @redirect-to-login="redirectToLogin"
    />

    <!-- Snackbar para mensagens -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="5000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import hostsService from '../services/hostsService'
import dashboardService from '../services/dashboardService'
import HostListItem from '../components/HostListItem.vue'
import LogViewer from '../components/LogViewer.vue'
import CronogramaConfig from '../components/CronogramaConfig.vue'
import UnifiedActionDialog from '../components/UnifiedActionDialog.vue'
import HorarioValidator from '../utils/HorarioValidator.js'
import configuracaoScoreService from '@/services/configuracaoScoreService'

// Verificação de segurança para o hostsService
if (!hostsService || typeof hostsService !== 'object') {
  console.error('[HomeView] hostsService não foi importado corretamente');
}

if (!hostsService.listHosts || typeof hostsService.listHosts !== 'function') {
  console.error('[HomeView] hostsService.listHosts não é uma função');
}

export default {
  name: 'HomeView',
  components: {
    HostListItem,
    LogViewer,
    CronogramaConfig,
    UnifiedActionDialog
  },
  data() {
    return {
      // Lista de hosts
      hosts: [],
      filteredHosts: [],
      allFilteredHosts: [], // Todos os hosts filtrados (quando há filtros aplicados, para scroll infinito)
      totalHosts: 0,
      loading: false,
      
      // Paginação
      pagination: {
        page: 1,
        itemsPerPage: 20, // Padrão: 20 itens por página
        pageOptions: [10, 20, 35, -1], // -1 significa "All"
        serverItemsLength: 0,
        loadingMore: false
      },
      showAllMode: false, // Modo "All" ativado (scroll infinito)
          allHostsLoaded: false, // Todos os hosts foram carregados
          currentPage: 1, // Página atual para carregamento (carrega 20 por vez)
          hostsDisplayedCount: 0, // Quantos hosts já foram exibidos no filteredHosts (para scroll infinito com hosts já carregados)
          loadMoreTimeout: null, // Timeout para debounce do carregamento
          scrollAnimationFrame: null, // RequestAnimationFrame para otimizar scroll handler
          heightCalculationTimeout: null, // Timeout para debounce do cálculo de altura
          scrollListenerAttached: false, // Flag para evitar reconfigurar scroll listener
          isChangingItemsPerPage: false, // Flag para indicar mudança intencional do itemsPerPage
          paginationVisibilityTimeout: null, // Timeout para debounce do ensurePaginationVisibility
          searchTimeout: null, // Timeout para debounce da busca
          isSearching: false, // Flag para indicar se está em modo de busca
          savedHostsState: null, // Estado dos hosts antes de entrar em modo busca (para restaurar depois)
      
      // Headers da tabela
      headers: [
        {
          text: 'Nome do Host',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'HostID',
          value: 'hostId',
          sortable: true,
          width: '120px',
        },
        {
          text: 'Porta',
          value: 'port',
          sortable: true,
        },
        {
          text: 'Sistemas',
          value: 'sistemas',
          sortable: false,
        },
        {
          text: 'Cronograma',
          value: 'cronograma',
          sortable: false,
          width: '100px',
          align: 'center',
        },
        {
          text: 'MacroMaster',
          value: 'macromaster',
          sortable: false,
          width: '180px',
        },
        {
          text: 'Ações',
          value: 'actions',
          sortable: false,
        },
      ],
      
      // Busca e filtros
      search: '',
      selectedPortas: [],
      selectedSistemas: [],
      showAdvancedFilters: false,
      mostrarTodosHosts: false,
      filtros: {
        nome: '',
        porta: null,
        sistema: '',
        versao: '',
        baseSizeMin: null,
        baseSizeMax: null
      },
      
      // Range de base_size (valores mínimo e máximo disponíveis)
      baseSizeRange: {
        min: 0,
        max: 100
      },
      loadingBaseSizeRange: false,
      
      // Valor do slider de base_size (array com [min, max])
      baseSizeSliderValue: [0, 100],
      
      // Indica se o slider está sendo arrastado (para feedback visual)
      isSliderActive: false,
      
      // Timeout para debouncing do filtro de base_size
      filtroBaseSizeTimeout: null,
      
      // Opções para filtros
      portasDisponiveis: [],
      sistemasDisponiveis: ['VCON', 'VPRA', 'VSUC', 'VSUP', 'VSYN'],
      
      // Diálogos
      unifiedDialog: false,
      atualizacaoDialog: false,
      cronogramaDialog: false,
      manualCronogramadoDialog: false,
      portaConfigDialog: false,
      selectedHost: null,
      atualizando: null,
      isSyncing: false,
      valid: true,
      salvandoPortaConfig: false,
      
      // Formulário de configurações de porta
      portaConfigForm: {
        porta_bloqueio: false,
        porta_liberado: false
      },
      
      // Agendamento manual cronogramado
      manualCronogramadoSistema: null,
      manualCronogramadoHorario: null,
      agendamentosManuaisExistentes: [],
      salvandoAgendamento: false,
      removendoAgendamento: false,
      sistemaRemovendo: null,
      // Formulário de agendamento manual cronogramado (múltiplos sistemas)
      manualCronogramadoForm: {
        vcon: false,
        vpra: false,
        vsuc: false,
        vsup: false,
        vsyn: false,
        horarioVcon: '',
        horarioVpra: '',
        horarioVsuc: '',
        horarioVsup: '',
        horarioVsyn: ''
      },
      horariosConflitantesManual: [],
      erroHorarioMinimo: null,
      erroHorarioMaximo: null,
      erroConflito10Minutos: null,
      templateValidationError: null,
      templatesVinculados: [],
      podeAtualizarVSUPManual: true,
      mensagemBloqueioVSUPManual: '',

      // Formulário de cronograma
      cronogramaForm: {
        vcon: false,
        vsup: false,
        vsuc: false,
        vpra: false,
        vsyn: false,
        horarioVcon: '00:00',
        horarioVpra: '00:00',
        horarioVsuc: '00:00',
        horarioVsup: '00:00',
        horarioVsyn: '00:00',
        logsVideo: false
      },
      
      // Dados completos do cronograma (incluindo host)
      cronogramaDataCompleto: null,
      
      // Validação de horários
      horariosConflitantes: [],
      temConflitosHorario: false,
      
      // Sistema de notificações
      snackbar: {
        show: false,
        text: '',
        color: 'info'
      },
      
      // Versões do sistema SCI
      latestVersions: {
        VCON: null,
        VPRA: null,
        VSUC: null,
        VSUP: null,
        VSYN: null
      },
      versionsLoaded: false,
      
      // Versão do MacroMaster
      macromasterVersion: null,
      macromasterLoaded: false,
      
      // Logs - refatorado para usar LogViewer
      logsDialog: false,
      
      // Novos filtros
      filtroSistemas: [],
      filtroStatusAtualizacao: null,
      filtroMacroMaster: null, // null = todos (padrão), 'com' = com MacroMaster, 'atualizado' = atualizado, 'desatualizado' = desatualizado, 'sem' = sem MacroMaster
      filtroCronograma: null, // null = todos, 'com' = tem cronograma, 'sem' = não tem cronograma
      statusAtualizacaoOptions: [
        { text: 'Atualizado', value: 'atualizado' },
        { text: 'Desatualizado', value: 'desatualizado' }
      ],
      sistemasParaFiltro: ['VCON', 'VPRA', 'VSUC', 'VSUP', 'VSYN'],
      aplicandoFiltros: false, // Flag para controlar loading do botão Aplicar
      
      // Observer para detectar mudanças na tabela
      tableObserver: null,
      
      // Intersection Observer para scroll infinito
      scrollObserver: null,
      
      // Configurações de score (carregadas do banco)
      databaseSizeLimitGB: 0,
      
      // Flags para prevenir chamadas duplicadas
      configuracoesScoreCarregando: false,
      configuracoesScoreCarregadas: false,
      systemVersionsCarregando: false
    };
  },

  created() {
    this.debouncedFetchHosts = this.debounce(this.fetchHosts, 300);
    // Carregar configurações apenas se ainda não foram carregadas
    if (!this.configuracoesScoreCarregadas && !this.configuracoesScoreCarregando) {
      this.carregarConfiguracoesScore();
    }
  },

  computed: {
    temFiltrosAtivos() {
      return this.numeroFiltrosAtivos > 0;
    },
    
    numeroFiltrosAtivos() {
      let count = 0;
      if (this.filtroSistemas.length > 0) count++;
      if (this.filtroStatusAtualizacao !== null) count++;
      if (this.filtroMacroMaster !== null) count++;
      if (this.filtroCronograma !== null) count++;
      if (this.filtros.baseSizeMin !== null || this.filtros.baseSizeMax !== null) {
        // Verificar se os valores são diferentes do range completo
        if (this.filtros.baseSizeMin !== this.baseSizeRange.min || 
            this.filtros.baseSizeMax !== this.baseSizeRange.max) {
          count++;
        }
      }
      return count;
    },
    
    macroMasterVersionFormatted() {
      if (!this.macromasterVersion || !this.macromasterLoaded) {
        return null;
      }
      return this.formatMacroMasterHash(this.macromasterVersion);
    },
    dialogWidth() {
      if (!this.selectedHost) return '800px'
      
      // Contar quantos sistemas o host possui
      let sistemasCount = 0
      if (this.selectedHost.hasVCON) sistemasCount++
      if (this.selectedHost.hasVPRA) sistemasCount++
      if (this.selectedHost.hasVSUC) sistemasCount++
      if (this.selectedHost.hasVSUP) sistemasCount++
      if (this.selectedHost.hasVSYN) sistemasCount++
      
      // Largura base: 200px por sistema + 200px de padding
      const baseWidth = 200
      const padding = 200
      const calculatedWidth = (sistemasCount * baseWidth) + padding
      
      // Largura mínima de 400px e máxima de 1200px
      const minWidth = 400
      const maxWidth = 1200
      
      return `${Math.max(minWidth, Math.min(maxWidth, calculatedWidth))}px`
    },
    sistemasDisponiveisParaAgendamento() {
      if (!this.selectedHost) return [];
      
      const sistemas = [];
      if (this.selectedHost.hasVCON) sistemas.push('VCON');
      if (this.selectedHost.hasVPRA) sistemas.push('VPRA');
      if (this.selectedHost.hasVSUC) sistemas.push('VSUC');
      if (this.selectedHost.hasVSUP) sistemas.push('VSUP');
      if (this.selectedHost.hasVSYN) sistemas.push('VSYN');
      
      return sistemas;
    },
    
    sistemasDesatualizados() {
      if (!this.selectedHost || !this.versionsLoaded) return [];
      
      const sistemas = [];
      const ordemHierarquica = ['VCON', 'VPRA', 'VSUC', 'VSUP', 'VSYN'];
      
      for (const sistema of ordemHierarquica) {
        const hasSystem = this.selectedHost[`has${sistema}`];
        if (!hasSystem) continue;
        
        const versionField = `${sistema.toLowerCase()}Version`;
        const currentVersion = this.selectedHost[versionField];
        const latestVersion = this.latestVersions[sistema];
        
        // Sistema está desatualizado se:
        // 1. Tem versão atual e versão mais recente disponível
        // 2. As versões são diferentes
        if (currentVersion && latestVersion && currentVersion !== latestVersion) {
          sistemas.push(sistema);
        }
      }
      
      return sistemas;
    },
    
    sistemasDisponiveisParaAgendamentoManual() {
      // Retorna sistemas desatualizados que ainda não têm agendamento
      const sistemas = this.sistemasDesatualizados;
      
      // Se há agendamentos existentes, remover os sistemas que já estão agendados
      if (this.agendamentosManuaisExistentes && this.agendamentosManuaisExistentes.length > 0) {
        const sistemasAgendados = this.agendamentosManuaisExistentes.map(a => a.sistema);
        return sistemas.filter(sistema => !sistemasAgendados.includes(sistema));
      }
      
      return sistemas;
    },
    
    agendamentosManuaisExistentesOrdenados() {
      // Ordena os agendamentos por horário (do mais cedo para o mais tarde)
      if (!this.agendamentosManuaisExistentes || this.agendamentosManuaisExistentes.length === 0) {
        return [];
      }
      
      const agendamentosOrdenados = [...this.agendamentosManuaisExistentes];
      
      // Função auxiliar para converter horário "HH:MM" em minutos totais
      const horarioParaMinutos = (horario) => {
        if (!horario || typeof horario !== 'string') return 0;
        const partes = horario.split(':');
        if (partes.length !== 2) return 0;
        const horas = parseInt(partes[0], 10) || 0;
        const minutos = parseInt(partes[1], 10) || 0;
        return horas * 60 + minutos;
      };
      
      agendamentosOrdenados.sort((a, b) => {
        const minutosA = horarioParaMinutos(a.horario);
        const minutosB = horarioParaMinutos(b.horario);
        
        // Ordenar por horário (mais cedo primeiro)
        if (minutosA !== minutosB) {
          return minutosA - minutosB;
        }
        
        // Se os horários forem iguais, manter ordem original
        return 0;
      });
      
      return agendamentosOrdenados;
    },
    
    dialogWidthManualCronogramado() {
      if (!this.selectedHost) return '600px';
      
      // Contar quantos sistemas desatualizados disponíveis para agendamento o host possui
      const sistemasCount = this.sistemasDisponiveisParaAgendamentoManual.length;
      
      if (sistemasCount === 0) return '600px';
      
      // Largura base: 200px por sistema + 200px de padding
      const baseWidth = 200;
      const padding = 200;
      
      // Largura mínima igual a dois sistemas: (2 * 200) + 200 = 600px
      const minWidthForTwoSystems = (2 * baseWidth) + padding; // 600px
      
      // Se tiver menos de 2 sistemas, usar a largura mínima de 2 sistemas
      // Se tiver 2 ou mais sistemas, calcular dinamicamente
      const sistemasCountToUse = Math.max(2, sistemasCount);
      const calculatedWidth = (sistemasCountToUse * baseWidth) + padding;
      
      // Largura máxima de 1200px
      const maxWidth = 1200;
      
      return `${Math.min(maxWidth, calculatedWidth)}px`;
    },
    
    temConflitosHorarioManual() {
      return !!this.erroHorarioMinimo || !!this.erroHorarioMaximo || !!this.erroConflito10Minutos;
    },
    
    temSistemasAgendados() {
      if (!this.manualCronogramadoForm) return false;
      
      // Verificar se exatamente um sistema está marcado para agendamento
      const sistemas = ['vcon', 'vpra', 'vsuc', 'vsup', 'vsyn'];
      const sistemasMarcados = sistemas.filter(sistema => {
        if (!this.manualCronogramadoForm[sistema]) return false;
        
        // Verificar se o horário está preenchido
        const horarioField = `horario${sistema.charAt(0).toUpperCase() + sistema.slice(1)}`;
        const horario = this.manualCronogramadoForm[horarioField];
        return horario && horario.trim() !== '';
      });
      
      // Deve ter exatamente um sistema agendado
      return sistemasMarcados.length === 1;
    },
  },

  mounted() {
    // Inicializar: FORÇAR modo All por padrão
    this.pagination.itemsPerPage = -1; // Forçar modo All por padrão
    this.pagination.pageOptions = [10, 20, 35, -1]; // Garantir que as opções estejam corretas
    this.pagination.page = 1;
    this.currentPage = 1;
    this.allHostsLoaded = false;
    this.loadMoreTimeout = null;
    this.showAllMode = true; // Forçar modo All ativado
    
    // Carregar primeiros 20 hosts (sem await, pois mounted não é async)
    // fetchHosts já carrega as versões dos sistemas quando reset = true, então não precisamos chamar loadSystemVersions() aqui
    this.fetchHosts(true, false).then(() => {
      // Após carregar hosts, configurar scroll infinito no modo All
      this.$nextTick(() => {
        if (this.showAllMode && this.hosts.length >= 20) {
          this.setupScrollListener();
          this.setupIntersectionObserver();
        }
      });
    });
    // Removido loadSystemVersions() daqui pois fetchHosts já faz isso quando reset = true
    this.loadMacroMasterVersion();
    this.buscarBaseSizeRange();
    this.calculateAvailableHeight();
    
    this.$root.$on('atualizacao-concluida', this.onAtualizacaoConcluida);
    this.$root.$on('versao-atualizada', this.onVersaoAtualizada);
    this.$root.$on('sincronizacao-concluida', this.onSincronizacaoConcluida);
    
    // Adicionar listener para redimensionamento da janela
    window.addEventListener('resize', this.calculateAvailableHeight);
    
    // Adicionar listener para mudanças na paginação da tabela
    this.$nextTick(() => {
      const tableElement = document.querySelector('.scrollable-table');
      if (tableElement) {
        // Observer para detectar mudanças no DOM da tabela
        const observer = new MutationObserver(() => {
          this.forceTableHeight();
        });
        
        observer.observe(tableElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        
        // Armazenar observer para limpeza posterior
        this.tableObserver = observer;
      }
      
      // Configurar listener de scroll inicial (será reconfigurado quando All for selecionado)
      // Não adicionar aqui, será adicionado quando necessário
    });
  },

  watch: {
    // Watcher para preservar itemsPerPage no modo All
    'pagination.itemsPerPage': {
      handler(newVal, oldVal) {
        // Ignorar se oldVal for undefined (inicialização)
        if (oldVal === undefined) return;
        
        // Se estava no modo All e tentou mudar para outro valor
        const wasAll = (oldVal === -1 || oldVal === '-1' || String(oldVal) === '-1');
        const isAll = (newVal === -1 || newVal === '-1' || String(newVal) === '-1');
        
        // Se estava no modo All e mudou para outro valor, mas showAllMode ainda está true
        // E não é uma mudança intencional (isChangingItemsPerPage = false)
        // Isso indica uma mudança não intencional (provavelmente do v-data-table)
        if (wasAll && !isAll && this.showAllMode && !this.isChangingItemsPerPage) {
          // Usar setTimeout para evitar conflito com outras atualizações
          setTimeout(() => {
            if (this.showAllMode && this.pagination.itemsPerPage !== -1 && !this.isChangingItemsPerPage) {
              this.pagination.itemsPerPage = -1;
            }
          }, 0);
        }
      },
      immediate: false
    },
    'cronogramaForm.horarioVpra': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.horarioVsuc': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.horarioVsup': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.horarioVcon': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.horarioVsyn': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.vpra': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.vsuc': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.vsup': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.vcon': {
      handler() {
        this.validarHorarios()
      }
    },
    'cronogramaForm.vsyn': {
      handler() {
        this.validarHorarios()
      }
    },
    
    // Watchers para agendamento manual cronogramado
    'manualCronogramadoForm.horarioVpra': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVsuc': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVsup': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVcon': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVsyn': {
      handler() {
        this.validarHorariosManual()
      }
    },
    // Watchers para horários do agendamento manual
    'manualCronogramadoForm.horarioVpra': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVsuc': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVsup': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVcon': {
      handler() {
        this.validarHorariosManual()
      }
    },
    'manualCronogramadoForm.horarioVsyn': {
      handler() {
        this.validarHorariosManual()
      }
    },
    
    // Recalcular altura quando filtros mudarem (com debounce para evitar muitas chamadas)
    filteredHosts: {
      handler() {
        // Debounce para evitar muitas chamadas durante scroll infinito
        if (this.heightCalculationTimeout) {
          clearTimeout(this.heightCalculationTimeout);
        }
        this.heightCalculationTimeout = setTimeout(() => {
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              this.calculateAvailableHeight();
            });
          });
        }, 300);
        
        // Debounce para ensurePaginationVisibility
        if (this.paginationVisibilityTimeout) {
          clearTimeout(this.paginationVisibilityTimeout);
        }
        this.paginationVisibilityTimeout = setTimeout(() => {
          this.ensurePaginationVisibility();
        }, 200);
      },
      deep: false // Não observar mudanças profundas, apenas referência do array
    },
    
    // Recalcular altura quando a lista de hosts mudar (com debounce)
    hosts: {
      handler() {
        // Debounce para evitar muitas chamadas durante scroll infinito
        if (this.heightCalculationTimeout) {
          clearTimeout(this.heightCalculationTimeout);
        }
        this.heightCalculationTimeout = setTimeout(() => {
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              this.calculateAvailableHeight();
            });
          });
        }, 300);
      },
      deep: false // Não observar mudanças profundas, apenas referência do array
    },
    
    // Watcher para busca de hosts (com debounce de 500ms)
    search: {
      handler(newValue, oldValue) {
        // Limpar timeout anterior
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        
        // Se o campo estiver vazio, voltar ao modo normal
        if (!newValue || newValue.trim() === '') {
          // Se estava em modo busca, restaurar estado anterior
          if (this.isSearching && this.savedHostsState) {
            this.isSearching = false;
            
            // Restaurar hosts e estado
            this.hosts = [...this.savedHostsState.hosts];
            this.totalHosts = this.savedHostsState.totalHosts;
            this.pagination.serverItemsLength = this.savedHostsState.totalHosts;
            this.currentPage = this.savedHostsState.currentPage;
            this.allHostsLoaded = this.savedHostsState.allHostsLoaded;
            
            // Aplicar filtros nos hosts restaurados
            this.filtrarHosts();
            
            // Reativar scroll infinito se estiver no modo All
            this.$nextTick(() => {
              if (this.showAllMode && this.hosts.length >= 20 && !this.allHostsLoaded) {
                this.setupScrollListener();
                this.setupIntersectionObserver();
              }
            });
            
            // Limpar estado salvo
            this.savedHostsState = null;
          } else {
            // Se não estava em modo busca, apenas garantir que não está em busca
            this.isSearching = false;
          }
          return;
        }
        
        // Se está entrando em modo busca pela primeira vez, salvar estado atual
        if (!this.isSearching && !this.savedHostsState) {
          this.savedHostsState = {
            hosts: [...this.hosts],
            totalHosts: this.totalHosts,
            currentPage: this.currentPage,
            allHostsLoaded: this.allHostsLoaded
          };
        }
        
        // Debounce de 500ms antes de fazer a busca
        this.searchTimeout = setTimeout(async () => {
          const searchTerm = newValue.trim();
          if (searchTerm === '') {
            this.isSearching = false;
            return;
          }
          
          this.isSearching = true;
          this.loading = true;
          
          try {
            // Buscar diretamente no backend
            const response = await hostsService.listHosts(1, 20, false, searchTerm);
            
            if (response.success && response.hosts) {
              // Substituir hosts carregados pelos resultados da busca
              this.hosts = response.hosts;
              this.totalHosts = response.totalHostsCount || response.hosts.length;
              this.pagination.serverItemsLength = this.totalHosts;
              this.allHostsLoaded = true; // Em modo busca, não há mais para carregar
              
              // Aplicar filtros nos resultados da busca
              this.filtrarHosts();
              
              // Desabilitar scroll infinito durante busca
              this.removeScrollListener();
              this.removeIntersectionObserver();
            }
          } catch (error) {
            console.error('[search] Erro ao buscar hosts:', error);
            this.showSnackbar('Erro ao buscar hosts', 'error');
          } finally {
            this.loading = false;
          }
        }, 500); // 500ms de debounce
      },
      immediate: false
    },
    
    // Watchers para sincronizar campos de base_size com o slider
    'filtros.baseSizeMin': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.updateSliderFromInput();
        }
      }
    },
    
    'filtros.baseSizeMax': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.updateSliderFromInput();
        }
      }
    },
    
    // Watcher para o range de base_size (quando carregado da API)
    baseSizeRange: {
      handler(newRange, oldRange) {
        if (newRange && (!oldRange || newRange.min !== oldRange.min || newRange.max !== oldRange.max)) {
          // Atualizar o slider quando o range é carregado/alterado
          this.baseSizeSliderValue = [newRange.min, newRange.max];
        }
      },
      deep: true
    }
  },

  beforeDestroy() {
    // Remover listener do evento para evitar vazamentos de memória
    this.$root.$off('atualizacao-concluida', this.onAtualizacaoConcluida);
    this.$root.$off('versao-atualizada', this.onVersaoAtualizada);
    this.$root.$off('sincronizacao-concluida', this.onSincronizacaoConcluida);
    
    // Remover listener de redimensionamento
    window.removeEventListener('resize', this.calculateAvailableHeight);
    
    // Limpar observer da tabela
    if (this.tableObserver) {
      this.tableObserver.disconnect();
    }
    
    // Limpar timeouts e animation frames se existirem
    if (this.loadMoreTimeout) {
      clearTimeout(this.loadMoreTimeout);
      this.loadMoreTimeout = null;
    }
    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
      this.scrollAnimationFrame = null;
    }
    if (this.heightCalculationTimeout) {
      clearTimeout(this.heightCalculationTimeout);
      this.heightCalculationTimeout = null;
    }
    // Remover listener de scroll
    this.removeScrollListener();
  },

  methods: {
    calculateAvailableHeight() {
      this.$nextTick(() => {
        // Altura flexível baseada no número de hosts filtrados
        const rowHeight = 48; // Altura aproximada de cada linha da tabela
        const headerHeight = 48; // Altura do cabeçalho da tabela
        const paginationHeight = 60; // Altura da paginação
        const tablePadding = 8; // Padding interno da tabela reduzido
        
        // SEMPRE usar 10 linhas como base (altura FIXA)
        // Independente do itemsPerPage, a tabela sempre terá a mesma altura
        // O scroll interno permitirá ver mais itens quando necessário
        const fixedRows = 10;
        
        // Altura total FIXA baseada em 10 linhas
        const fixedTableHeight = headerHeight + (rowHeight * fixedRows) + paginationHeight + tablePadding;
        
        // Remover log para reduzir overhead (comentar se precisar debug)
        // console.log('[calculateAvailableHeight] Altura FIXA calculada:', {
        //   fixedRows,
        //   rowHeight,
        //   headerHeight,
        //   paginationHeight,
        //   tablePadding,
        //   fixedTableHeight,
        //   itemsPerPage: this.pagination.itemsPerPage,
        //   totalItems: this.filteredHosts.length
        // });
        
        const tableElement = document.querySelector('.scrollable-table');
        const tableWrapper = document.querySelector('.scrollable-table .v-data-table__wrapper');
        const tableCard = document.querySelector('.content-section .modern-card');
        
        if (tableElement) {
          tableElement.style.height = `${fixedTableHeight}px`;
          tableElement.style.maxHeight = `${fixedTableHeight}px`;
          tableElement.style.overflow = 'hidden';
        }
        
        if (tableWrapper) {
          const tableContentHeight = fixedTableHeight - paginationHeight;
          tableWrapper.style.height = `${tableContentHeight}px`;
          tableWrapper.style.maxHeight = `${tableContentHeight}px`;
          tableWrapper.style.overflowY = 'auto';
          tableWrapper.style.overflowX = 'hidden';
          tableWrapper.style.position = 'relative';
          // Forçar scroll mesmo com poucos itens
          tableWrapper.style.display = 'block';
        }
        
        if (tableCard) {
          tableCard.style.height = `${fixedTableHeight}px`;
          tableCard.style.maxHeight = `${fixedTableHeight}px`;
          tableCard.style.overflow = 'hidden';
        }
        
        // Remover log para reduzir overhead (comentar se precisar debug)
        // console.log('[calculateAvailableHeight] Altura aplicada:', fixedTableHeight);
        
        // Garantir que a paginação seja sempre visível (com debounce já implementado no watcher)
        // Remover chamada direta para evitar muitas execuções
        // this.ensurePaginationVisibility();
      });
    },

    ensurePaginationVisibility() {
      // Debounce agressivo para evitar muitas chamadas
      if (this.paginationVisibilityTimeout) {
        clearTimeout(this.paginationVisibilityTimeout);
      }
      
      this.paginationVisibilityTimeout = setTimeout(() => {
        this.$nextTick(() => {
          // Usar requestAnimationFrame para otimizar atualizações de DOM
          requestAnimationFrame(() => {
            const footer = document.querySelector('.scrollable-table .v-data-table__footer');
            const pagination = document.querySelector('.scrollable-table .v-data-footer');
            
            if (footer) {
              footer.style.display = 'block';
              footer.style.visibility = 'visible';
              footer.style.height = '60px';
              footer.style.minHeight = '60px';
            }
            
            if (pagination) {
              pagination.style.display = 'flex';
              pagination.style.visibility = 'visible';
              pagination.style.alignItems = 'center';
              pagination.style.justifyContent = 'space-between';
            }
            
            // Remover log para reduzir overhead
            // console.log('[ensurePaginationVisibility] Paginação forçada a ser visível');
          });
        });
      }, 200);
    },

    async carregarConfiguracoesScore() {
      // Prevenir chamadas duplicadas
      if (this.configuracoesScoreCarregando || this.configuracoesScoreCarregadas) {
        return;
      }
      
      this.configuracoesScoreCarregando = true;
      try {
        const response = await configuracaoScoreService.buscarComoObjeto()
        if (response && response.success && response.configuracoes) {
          this.databaseSizeLimitGB = parseFloat(response.configuracoes.DATABASE_SIZE_LIMIT_GB) || 0
          this.configuracoesScoreCarregadas = true;
        } else {
          this.databaseSizeLimitGB = 0
          console.warn('Não foi possível carregar DATABASE_SIZE_LIMIT_GB do banco de dados. Resposta:', response)
          // Se não houver configurações, ainda marcar como carregado para não ficar tentando infinitamente
          this.configuracoesScoreCarregadas = true;
        }
      } catch (error) {
        console.error('Erro ao carregar configurações de score:', error)
        this.databaseSizeLimitGB = 0
        // Em caso de erro, permitir tentar novamente na próxima vez
        this.configuracoesScoreCarregadas = false;
      } finally {
        this.configuracoesScoreCarregando = false;
      }
    },

    debounce(fn, delay) {
      let timeoutId;
      return function (...args) {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
          fn.apply(this, args);
          timeoutId = null;
        }, delay);
      };
    },

    async fetchHosts(reset = true, append = false, filters = null) {
      // Se estiver em modo de busca, não fazer fetch normal
      if (this.isSearching && this.search && this.search.trim() !== '') {
        return;
      }
      
      try {
        // Se não for append, mostrar loading principal
        if (!append) {
          this.loading = true;
        } else {
          this.pagination.loadingMore = true;
        }
        
        // Verificação de segurança antes de chamar o método
        if (!hostsService) {
          throw new Error('hostsService não está disponível');
        }
        
        // Modo scroll infinito fixo: sempre carregar 20 em 20
        const pageToFetch = this.currentPage;
        const limitToFetch = 20; // Sempre carregar 20 hosts por vez
        
        // Preparar filtros para enviar ao backend
        const filtersToSend = filters || this.getFiltersForBackend();
        
        // Buscar hosts com paginação
        let response;
        if (typeof hostsService.listHosts === 'function') {
          response = await hostsService.listHosts(pageToFetch, limitToFetch, false, '', filtersToSend);
        } else if (typeof hostsService.getHosts === 'function') {
          response = await hostsService.getHosts(pageToFetch, limitToFetch, false);
        } else {
          throw new Error('Nenhum método de busca de hosts disponível no hostsService');
        }
        
        // Verificar se a resposta inclui o campo success
        if (response && response.success === false) {
          throw new Error(response.message || 'Erro ao buscar hosts');
        }
        
        // Verificar se hosts existe na resposta
        if (!response || !response.hosts || !Array.isArray(response.hosts)) {
          throw new Error('Resposta da API não contém lista de hosts válida');
        }
        
        // Processar hosts recebidos
        const uniqueHosts = Array.from(new Map(response.hosts.map(host => [host.hostId, host])).values());
        
        // Se for append (scroll infinito), adicionar aos hosts existentes
        if (append) {
          // Verificar se há duplicatas antes de adicionar
          const existingHostIds = new Set(this.hosts.map(h => h.hostId));
          const newHosts = uniqueHosts.filter(h => !existingHostIds.has(h.hostId));
          this.hosts = [...this.hosts, ...newHosts];
        } else {
          // Resetar lista de hosts
          this.hosts = uniqueHosts;
        }
        
        // Atualizar informações de paginação
        this.totalHosts = response.totalHostsCount || 0;
        this.pagination.serverItemsLength = this.totalHosts;
        
        // Verificar se todos os hosts foram carregados
        const totalLoaded = this.hosts.length;
        const hostsNestaPagina = response.hosts.length;
        const hasMore = response.hasMore !== false; // Se não tiver hasMore na resposta, assumir que há mais
        
        // Determinar se todos os hosts foram carregados:
        // 1. Se o total carregado >= total disponível E total disponível > 0, todos foram carregados
        // 2. Se não recebemos hosts nesta página E não estamos na primeira página, não há mais
        // 3. Se recebemos menos hosts que o limite (20) E não estamos na primeira página, não há mais
        // 4. Se o backend explicitamente indicar que não há mais (hasMore === false)
        const isFirstPage = this.currentPage === 1;
        const recebeuMenosQueOLimite = hostsNestaPagina > 0 && hostsNestaPagina < limitToFetch && !isFirstPage;
        const naoRecebeuHostsENaoEPrimeiraPagina = hostsNestaPagina === 0 && !isFirstPage;
        const todosCarregadosPorTotal = this.totalHosts > 0 && totalLoaded >= this.totalHosts;
        
        this.allHostsLoaded = todosCarregadosPorTotal 
          || naoRecebeuHostsENaoEPrimeiraPagina 
          || recebeuMenosQueOLimite
          || (hostsNestaPagina === 0 && hasMore === false);
        
        // Se não há mais hosts para carregar, remover sentinela
        if (this.allHostsLoaded) {
          const sentinel = document.getElementById('scroll-sentinel');
          if (sentinel) {
            sentinel.style.display = 'none';
          }
        }
        
        // Recarregar as versões dos sistemas apenas na primeira carga
        if (reset || !this.versionsLoaded) {
          await this.loadSystemVersions();
        }
 
        // Aplicar filtro de hosts
        // Se for append, filtrar apenas os novos hosts e mesclar (otimização de performance)
        if (append && this.hosts.length > 20) {
          // Filtrar apenas os novos hosts adicionados
          // Filtrar apenas os novos hosts adicionados (otimização de performance)
          const novosHostsFiltrados = this.filtrarHostsArray(uniqueHosts);
          // Adicionar aos hosts filtrados existentes
          const existingHostIds = new Set(this.filteredHosts.map(h => h.hostId));
          const novosSemDuplicatas = novosHostsFiltrados.filter(h => !existingHostIds.has(h.hostId));
          
          // Usar push para evitar recriar array inteiro (mais eficiente)
          if (novosSemDuplicatas.length > 0) {
            this.filteredHosts.push(...novosSemDuplicatas);
          }
          
          // Remover log para reduzir overhead (comentar se precisar debug)
          // console.log('[fetchHosts] Filtro otimizado: novos hosts filtrados:', novosSemDuplicatas.length, 'Total filtrado:', this.filteredHosts.length);
        } else {
          // Filtrar todos os hosts (reset ou primeira carga)
          this.filtrarHosts();
        }
        
        // Forçar altura da tabela após carregar dados (debounce mais agressivo para evitar múltiplas chamadas)
        if (this.heightCalculationTimeout) {
          clearTimeout(this.heightCalculationTimeout);
        }
        // Aumentar debounce para 300ms para evitar muitas chamadas durante scroll
        this.heightCalculationTimeout = setTimeout(() => {
          this.$nextTick(() => {
            // Usar requestAnimationFrame para otimizar atualizações de DOM
            requestAnimationFrame(() => {
              this.calculateAvailableHeight();
            });
          });
        }, 300);
        
        // Configurar scroll listener apenas no modo All (evitar reconfigurar se já estiver configurado)
        this.$nextTick(() => {
          const itemsPerPageValue = this.pagination.itemsPerPage;
          const isAllMode = (itemsPerPageValue === -1 || itemsPerPageValue === '-1' || String(itemsPerPageValue) === '-1') || this.showAllMode;
          
          // Garantir que itemsPerPage continue -1 se estiver no modo All
          if (isAllMode || this.showAllMode) {
            if (this.pagination.itemsPerPage !== -1) {
              this.pagination.itemsPerPage = -1;
            }
            this.showAllMode = true;
          }
          
          // Se adicionou hosts no modo All, atualizar Intersection Observer apenas se necessário
          if (append && (isAllMode || this.showAllMode)) {
            // Verificar se o observer já existe antes de reconfigurar
            if (!this.scrollObserver) {
              this.setupIntersectionObserver();
            } else {
              // Apenas mover o sentinela para o final
              this.updateSentinelPosition();
            }
          }
          
          // Configurar scroll listener apenas se não existir
          if ((isAllMode || this.showAllMode) && !this.scrollListenerAttached) {
            this.setupScrollListener();
            this.scrollListenerAttached = true;
          }
          
          // Proteção final: garantir que itemsPerPage continue -1 no modo All após todas as operações
          if (isAllMode || this.showAllMode) {
            this.$nextTick(() => {
              if (this.pagination.itemsPerPage !== -1) {
                this.pagination.itemsPerPage = -1;
              }
            });
          }
        });
      } catch (error) {
        console.error('Erro ao buscar hosts:', error);
        this.showSnackbar(error.message || 'Erro ao buscar hosts', 'error');
      } finally {
        this.loading = false;
        this.pagination.loadingMore = false;
      }
    },
    
    // Método para carregar mais hosts no scroll infinito (apenas no modo All)
    async loadMoreHosts() {
      // Verificar se está no modo All
      const itemsPerPageValue = this.pagination.itemsPerPage;
      const isAllMode = (itemsPerPageValue === -1 || itemsPerPageValue === '-1' || String(itemsPerPageValue) === '-1');
      
      // Verificar condições antes de carregar
      if (!isAllMode || this.pagination.loadingMore || this.allHostsLoaded) {
        return;
      }
      
      // Limpar timeout anterior se existir
      if (this.loadMoreTimeout) {
        clearTimeout(this.loadMoreTimeout);
        this.loadMoreTimeout = null;
      }
      
      this.pagination.loadingMore = true;
      
      try {
        // Verificar se todos os hosts já estão carregados (caso de filtros aplicados)
        // Se allFilteredHosts tem hosts e hostsDisplayedCount < allFilteredHosts.length, significa que há mais hosts para mostrar
        if (this.allFilteredHosts.length > 0 && this.hostsDisplayedCount < this.allFilteredHosts.length) {
          // Todos os hosts já estão carregados, apenas mostrar mais no filteredHosts
          const nextBatch = this.allFilteredHosts.slice(this.hostsDisplayedCount, this.hostsDisplayedCount + 20);
          this.filteredHosts = [...this.filteredHosts, ...nextBatch];
          this.hostsDisplayedCount += nextBatch.length;
          
          // Verificar se todos foram exibidos
          if (this.hostsDisplayedCount >= this.allFilteredHosts.length) {
            this.allHostsLoaded = true;
          }
        } else {
          // Buscar mais hosts do backend (comportamento normal)
          this.currentPage++;
          
          // Salvar o itemsPerPage atual antes de carregar (para não perder o modo All)
          const savedItemsPerPage = this.pagination.itemsPerPage;
          const savedShowAllMode = this.showAllMode;
          
          // Obter filtros atuais para aplicar também no scroll infinito
          const filters = this.getFiltersForBackend();
          
          await this.fetchHosts(false, true, filters);
          
          // Restaurar o itemsPerPage após carregar (garantir que continue no modo All)
          this.$nextTick(() => {
            if (savedItemsPerPage === -1) {
              this.pagination.itemsPerPage = -1;
              this.showAllMode = savedShowAllMode;
              // Proteção adicional: garantir que continue -1 após múltiplos nextTick
              this.$nextTick(() => {
                if (this.pagination.itemsPerPage !== -1) {
                  this.pagination.itemsPerPage = -1;
                }
              });
            }
          });
        }
      } catch (error) {
        console.error('[loadMoreHosts] Erro ao carregar mais hosts:', error);
        this.showSnackbar('Erro ao carregar mais hosts', 'error');
        // Reverter o incremento da página em caso de erro
        if (this.currentPage > 1) {
          this.currentPage--;
        }
      } finally {
        this.pagination.loadingMore = false;
      }
    },
    
    // Handler para mudança de página
    async onPageChange(page) {
      this.pagination.page = page;
      // Não precisa carregar mais hosts, pois os hosts já estão carregados (20 inicialmente)
    },
    
    // Handler para mudança de items per page
    async onItemsPerPageChange(itemsPerPage) {
      // Marcar que esta é uma mudança intencional
      this.isChangingItemsPerPage = true;
      
      // Proteção: Se já estiver no modo All, verificar se o novo valor é válido
      const currentIsAll = (this.pagination.itemsPerPage === -1 || this.pagination.itemsPerPage === '-1' || String(this.pagination.itemsPerPage) === '-1');
      const newIsAll = (itemsPerPage === -1 || itemsPerPage === '-1' || String(itemsPerPage) === '-1');
      
      // Se está no modo All e recebeu um valor que não é -1 e não está nas opções válidas
      // Isso significa que o v-data-table está emitindo o número de itens filtrados
      // Devemos ignorar isso e manter o modo All
      if (this.showAllMode && !newIsAll) {
        const parsedValue = parseInt(itemsPerPage, 10);
        if (!this.pagination.pageOptions.includes(parsedValue)) {
          this.pagination.itemsPerPage = -1;
          this.showAllMode = true;
          this.isChangingItemsPerPage = false;
          return;
        }
      }
      
      if (currentIsAll && newIsAll) {
        // Já está no modo All e continua no modo All - pode ser um evento não intencional do v-data-table
        this.pagination.itemsPerPage = -1;
        this.showAllMode = true;
        this.isChangingItemsPerPage = false;
        return;
      }
      
      // Se selecionou "All" (-1 ou string "-1")
      if (newIsAll) {
        this.showAllMode = true;
        this.pagination.itemsPerPage = -1;
        this.pagination.page = 1;
        this.currentPage = 1;
        this.allHostsLoaded = false;
        
        // Se já tiver 20 hosts carregados, apenas mostrar todos
        // Se não tiver, carregar os primeiros 20
        if (this.hosts.length < 20) {
          await this.fetchHosts(true, false);
        }
        
        // Configurar scroll infinito após carregar hosts no modo All
        this.$nextTick(() => {
          if (this.hosts.length >= 20) {
            this.setupScrollListener();
            this.setupIntersectionObserver();
          }
          // Garantir que itemsPerPage continue -1 após nextTick
          this.pagination.itemsPerPage = -1;
        });
        
        // Resetar flag após configurar
        this.$nextTick(() => {
          this.isChangingItemsPerPage = false;
        });
      } else {
        // Modo paginação normal (10, 20, 35)
        const parsedValue = parseInt(itemsPerPage, 10);
        
        // Validar se o valor está nas opções permitidas
        if (!this.pagination.pageOptions.includes(parsedValue)) {
          this.pagination.itemsPerPage = 20;
          return;
        }
        
        this.showAllMode = false;
        this.pagination.itemsPerPage = parsedValue;
        this.pagination.page = 1;
        this.currentPage = 1;
        this.allHostsLoaded = false;
        
        // Remover listener de scroll no modo paginação normal
        this.removeScrollListener();
        this.removeIntersectionObserver();
        
        // Se não tiver hosts carregados, carregar os primeiros 20
        if (this.hosts.length === 0) {
          await this.fetchHosts(true, false);
        }
        
        // Se o itemsPerPage for maior que os hosts carregados, carregar mais
        if (this.hosts.length < this.pagination.itemsPerPage) {
          // Calcular quantos hosts precisam ser carregados
          const hostsNecessarios = Math.max(20, this.pagination.itemsPerPage);
          if (this.hosts.length < hostsNecessarios) {
            // Carregar mais hosts se necessário
            const paginasNecessarias = Math.ceil(hostsNecessarios / 20);
            for (let i = 2; i <= paginasNecessarias; i++) {
              this.currentPage = i;
              await this.fetchHosts(false, true);
            }
          }
        }
        
        // Resetar flag após configurar
        this.$nextTick(() => {
          this.isChangingItemsPerPage = false;
        });
      }
    },
    
    // Configurar listener de scroll
    setupScrollListener() {
      // Evitar reconfigurar se já estiver configurado
      if (this.scrollListenerAttached) {
        return;
      }
      
      this.$nextTick(() => {
        // Tentar encontrar o wrapper da tabela
        const tableWrapper = document.querySelector('.scrollable-table .v-data-table__wrapper');
        if (tableWrapper) {
          // Remover listener anterior se existir
          tableWrapper.removeEventListener('scroll', this.handleTableScroll);
          // Adicionar novo listener
          tableWrapper.addEventListener('scroll', this.handleTableScroll, { passive: true });
          this.scrollListenerAttached = true;
          
          // Também usar Intersection Observer como backup (apenas se não existir)
          if (!this.scrollObserver) {
            this.setupIntersectionObserver();
          }
        } else {
          // Tentar novamente após um pequeno delay
          setTimeout(() => {
            this.setupScrollListener();
          }, 500);
        }
      });
    },
    
    // Atualizar posição do sentinela (mais rápido que reconfigurar tudo)
    updateSentinelPosition() {
      const sentinel = document.getElementById('scroll-sentinel');
      const tableBody = document.querySelector('.scrollable-table .v-data-table__wrapper table tbody');
      if (sentinel && tableBody) {
        // Mover sentinela para o final
        tableBody.appendChild(sentinel);
      }
    },
    
    // Configurar Intersection Observer para detectar quando chegar ao final
    setupIntersectionObserver() {
      // Evitar reconfigurar se já estiver configurado
      if (this.scrollObserver) {
        this.updateSentinelPosition();
        return;
      }
      
      this.$nextTick(() => {
        // Criar um elemento sentinela no final da tabela
        const tableWrapper = document.querySelector('.scrollable-table .v-data-table__wrapper');
        const tableBody = document.querySelector('.scrollable-table .v-data-table__wrapper table tbody');
        
        if (!tableWrapper || !tableBody) {
          return;
        }
        
        // Criar ou atualizar elemento sentinela
        let sentinel = document.getElementById('scroll-sentinel');
        if (!sentinel) {
          sentinel = document.createElement('tr');
          sentinel.id = 'scroll-sentinel';
          const td = document.createElement('td');
          td.colSpan = 100; // Colspan grande para ocupar toda a largura
          td.style.height = '1px';
          td.style.padding = '0';
          td.style.margin = '0';
          sentinel.appendChild(td);
          tableBody.appendChild(sentinel);
        } else {
          // Mover sentinela para o final da tabela
          tableBody.appendChild(sentinel);
        }
        
        // Configurar Intersection Observer com debounce (apenas no modo All)
        this.scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Verificar se está no modo All
              const itemsPerPageValue = this.pagination.itemsPerPage;
              const isAllMode = (itemsPerPageValue === -1 || itemsPerPageValue === '-1' || String(itemsPerPageValue) === '-1');
              
              // Verificar condições antes de processar
              if (!isAllMode || this.pagination.loadingMore || this.allHostsLoaded) {
                return;
              }
              
              // Limpar timeout anterior se existir
              if (this.loadMoreTimeout) {
                clearTimeout(this.loadMoreTimeout);
              }
              
              // Remover debounce completamente quando muito visível (intersectionRatio alto)
              // O rootMargin já faz o trabalho de detectar antes, então podemos carregar imediatamente
              const shouldLoadImmediately = entry.intersectionRatio > 0.3;
              
              if (shouldLoadImmediately) {
                // Carregar imediatamente quando muito visível
                const currentItemsPerPageValue = this.pagination.itemsPerPage;
                const currentIsAllMode = (currentItemsPerPageValue === -1 || currentItemsPerPageValue === '-1' || String(currentItemsPerPageValue) === '-1');
                
                if (currentIsAllMode && !this.pagination.loadingMore && !this.allHostsLoaded) {
                  this.loadMoreHosts();
                }
              } else {
                // Apenas quando pouco visível, usar um delay mínimo
                this.loadMoreTimeout = setTimeout(() => {
                  const currentItemsPerPageValue = this.pagination.itemsPerPage;
                  const currentIsAllMode = (currentItemsPerPageValue === -1 || currentItemsPerPageValue === '-1' || String(currentItemsPerPageValue) === '-1');
                  
                  if (currentIsAllMode && !this.pagination.loadingMore && !this.allHostsLoaded) {
                    this.loadMoreHosts();
                  }
                  this.loadMoreTimeout = null;
                }, 50);
              }
            }
          });
        }, {
          root: tableWrapper,
          rootMargin: '400px', // Carregar quando estiver a 400px do final (aumentado de 50px)
          threshold: 0.01 // Disparar mesmo com 1% visível
        });
        
        this.scrollObserver.observe(sentinel);
      });
    },
    
    // Remover listener de scroll
    removeScrollListener() {
      const tableWrapper = document.querySelector('.scrollable-table .v-data-table__wrapper');
      if (tableWrapper) {
        tableWrapper.removeEventListener('scroll', this.handleTableScroll);
      }
      
      // Remover Intersection Observer
      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
        this.scrollObserver = null;
      }
      
      // Remover elemento sentinela
      const sentinel = document.getElementById('scroll-sentinel');
      if (sentinel) {
        sentinel.remove();
      }
    },
    
    removeIntersectionObserver() {
      // Remover Intersection Observer se existir
      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
        this.scrollObserver = null;
      }
      
      // Remover elemento sentinela
      const sentinel = document.getElementById('scroll-sentinel');
      if (sentinel) {
        sentinel.remove();
      }
    },
    
    // Handler para scroll da tabela (scroll infinito - apenas no modo All)
    handleTableScroll(event) {
      // Usar requestAnimationFrame para melhor performance com muitas linhas
      if (this.scrollAnimationFrame) {
        cancelAnimationFrame(this.scrollAnimationFrame);
      }
      
      this.scrollAnimationFrame = requestAnimationFrame(() => {
        // Verificar se está no modo All
        const itemsPerPageValue = this.pagination.itemsPerPage;
        const isAllMode = (itemsPerPageValue === -1 || itemsPerPageValue === '-1' || String(itemsPerPageValue) === '-1');
        
        // Verificar condições
        if (!isAllMode || this.allHostsLoaded || this.pagination.loadingMore) {
          this.scrollAnimationFrame = null;
          return;
        }
        
        const tableWrapper = event.target || event.currentTarget;
        if (!tableWrapper) {
          this.scrollAnimationFrame = null;
          return;
        }
        
        // Calcular se está próximo do final (aumentado para 500px para começar antes)
        const scrollTop = tableWrapper.scrollTop || 0;
        const scrollHeight = tableWrapper.scrollHeight || 0;
        const clientHeight = tableWrapper.clientHeight || 0;
        const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
        
        // Se estiver a menos de 500px do final, carregar mais
        if (distanceFromBottom < 500 && distanceFromBottom > 0) {
          // Limpar timeout anterior se existir
          if (this.loadMoreTimeout) {
            clearTimeout(this.loadMoreTimeout);
          }
          
          // Remover debounce completamente quando muito próximo (< 100px)
          // Usar delay mínimo quando próximo (< 300px)
          // Delay normal quando ainda está longe (< 500px)
          let debounceDelay = 0;
          if (distanceFromBottom < 100) {
            debounceDelay = 0; // Sem delay quando muito próximo
          } else if (distanceFromBottom < 300) {
            debounceDelay = 50; // Delay mínimo
          } else {
            debounceDelay = 100; // Delay normal
          }
          
          // Se não há delay, carregar imediatamente
          if (debounceDelay === 0) {
            if (!this.pagination.loadingMore && !this.allHostsLoaded) {
              this.loadMoreHosts();
            }
          } else {
            // Usar debounce apenas quando necessário
            this.loadMoreTimeout = setTimeout(() => {
              if (!this.pagination.loadingMore && !this.allHostsLoaded) {
                this.loadMoreHosts();
              }
              this.loadMoreTimeout = null;
            }, debounceDelay);
          }
        }
        
        this.scrollAnimationFrame = null;
      });
    },
    
    // Método para compatibilidade com v-data-table (não usado, mas mantido)
    onTableScroll(event) {
      this.handleTableScroll(event);
    },

    async syncHosts() {
      this.isSyncing = true;
      try {
        const response = await hostsService.syncHosts();
        
        // Verificar se a resposta inclui o campo success
        if (response && response.success === false) {
          throw new Error(response.message || 'Erro ao sincronizar hosts');
        }
        
        // O resultado será recebido via WebSocket através do evento 'sincronizacao-concluida'
      } catch (error) {
        console.error('Erro ao iniciar sincronização de hosts:', error);
        this.showSnackbar(error.message || 'Erro ao iniciar sincronização', 'error');
        this.isSyncing = false;
      }
      // Não resetamos isSyncing aqui, será resetado quando receber o evento WebSocket
    },

    /**
     * Handler para evento de sincronização concluída via WebSocket
     */
    async onSincronizacaoConcluida(dadosSincronizacao) {
      // Resetar o estado de sincronização
      this.isSyncing = false;
      
      try {
        // Buscar a lista atualizada de hosts
        await this.fetchHosts();
      } catch (error) {
        console.error('[onSincronizacaoConcluida] Erro ao atualizar hosts:', error);
      }
    },

    async openUnifiedDialog(host) {
      // Validar bloqueio de porta antes de abrir o diálogo
      if (host.porta_bloqueio === true) {
        if (host.porta_liberado !== true) {
          this.showSnackbar('Este host possui bloqueio de porta, realize a liberação para poder configurar o cronograma.', 'error');
          return;
        }
      }

      this.selectedHost = host;
      
      // Verificar se há atualizações pendentes para este host
      try {
        const response = await hostsService.verificarAndamento(host.hostId);
        
        if (response && response.success) {
          if (response.emAndamento) {
            // Se há atualização em andamento, definir o sistema que está sendo atualizado
            this.atualizando = response.controle.sistema;
          } else {
            // Limpar estado de atualização se não há nada pendente
            this.atualizando = null;
          }
        }
      } catch (error) {
        console.error('[openUnifiedDialog] Erro ao verificar atualizações pendentes:', error);
        // Em caso de erro, limpar estado de atualização para permitir tentativas
        this.atualizando = null;
      }
      
      this.unifiedDialog = true;
    },

    async openCronogramaDialog(host) {
      // Validar bloqueio de porta antes de abrir o diálogo
      if (host.porta_bloqueio === true) {
        if (host.porta_liberado !== true) {
          this.showSnackbar('Este host possui bloqueio de porta, realize a liberação para poder configurar o cronograma.', 'error');
          return;
        }
      }

      this.selectedHost = host;
      this.resetCronogramaForm();
      
      // Indicador visual de carregamento
      this.salvandoCronograma = true;

      try {
        const response = await hostsService.getCronogramaByHostId(host.hostId);
        
        if (response && response.success === false) {
          throw new Error(response.message || 'Erro ao buscar cronograma');
        }
        
        const cronograma = response.cronograma || response;
        
        // Garantir que os valores booleanos sejam corretamente processados
        const valoresParsed = {
          vcon: cronograma.vcon === true || cronograma.vcon === 'true',
          vpra: cronograma.vpra === true || cronograma.vpra === 'true',
          vsuc: cronograma.vsuc === true || cronograma.vsuc === 'true',
          vsup: cronograma.vsup === true || cronograma.vsup === 'true',
          vsyn: cronograma.vsyn === true || cronograma.vsyn === 'true',
          horarioVcon: cronograma.horarioVcon,
          horarioVpra: cronograma.horarioVpra,
          horarioVsuc: cronograma.horarioVsuc,
          horarioVsup: cronograma.horarioVsup,
          horarioVsyn: cronograma.horarioVsyn,
          logsVideo: cronograma.logsVideo === true || cronograma.logsVideo === 'true',
          jobsAgendados: cronograma.jobsAgendados === true || cronograma.jobsAgendados === 'true',
          id: cronograma.id,
          hostId: cronograma.hostId,
          createdAt: cronograma.createdAt,
          updatedAt: cronograma.updatedAt
        };
        
        // Criar objeto completo com host incluído
        this.cronogramaDataCompleto = {
          ...valoresParsed,
          host: host
        };
        
        // Converter strings para boolean
        this.cronogramaForm.vcon = valoresParsed.vcon;
        this.cronogramaForm.vsup = valoresParsed.vsup;
        this.cronogramaForm.vsuc = valoresParsed.vsuc;
        this.cronogramaForm.vpra = valoresParsed.vpra;
        this.cronogramaForm.vsyn = valoresParsed.vsyn;
        this.cronogramaForm.logsVideo = valoresParsed.logsVideo;
        
        // Formatar os horários para o formato HH:MM
        if (cronograma.horarioVcon) {
          const horarioVcon = new Date(`2000-01-01T${cronograma.horarioVcon}`);
          this.cronogramaForm.horarioVcon = `${String(horarioVcon.getHours()).padStart(2, '0')}:${String(horarioVcon.getMinutes()).padStart(2, '0')}`;
        }
        
        if (cronograma.horarioVpra) {
          const horarioVpra = new Date(`2000-01-01T${cronograma.horarioVpra}`);
          this.cronogramaForm.horarioVpra = `${String(horarioVpra.getHours()).padStart(2, '0')}:${String(horarioVpra.getMinutes()).padStart(2, '0')}`;
        }
        
        if (cronograma.horarioVsuc) {
          const horarioVsuc = new Date(`2000-01-01T${cronograma.horarioVsuc}`);
          this.cronogramaForm.horarioVsuc = `${String(horarioVsuc.getHours()).padStart(2, '0')}:${String(horarioVsuc.getMinutes()).padStart(2, '0')}`;
        }
        
        if (cronograma.horarioVsup) {
          const horarioVsup = new Date(`2000-01-01T${cronograma.horarioVsup}`);
          this.cronogramaForm.horarioVsup = `${String(horarioVsup.getHours()).padStart(2, '0')}:${String(horarioVsup.getMinutes()).padStart(2, '0')}`;
        }
        
        if (cronograma.horarioVsyn) {
          const horarioVsyn = new Date(`2000-01-01T${cronograma.horarioVsyn}`);
          this.cronogramaForm.horarioVsyn = `${String(horarioVsyn.getHours()).padStart(2, '0')}:${String(horarioVsyn.getMinutes()).padStart(2, '0')}`;
        }
        
        // Aguardar um tempo suficiente para garantir que todos os dados foram processados
        await new Promise(resolve => setTimeout(resolve, 100));
        
      } catch (error) {
        // Nenhum cronograma encontrado para este host
        
        // Criar objeto completo mesmo sem cronograma
        this.cronogramaDataCompleto = {
          vcon: false,
          vsup: false,
          vsuc: false,
          vpra: false,
          vsyn: false,
          horarioVcon: '00:00:00',
          horarioVpra: '00:00:00',
          horarioVsuc: '00:00:00',
          horarioVsup: '00:00:00',
          horarioVsyn: '00:00:00',
          logsVideo: false,
          host: host
        };
      } finally {
        // Desativar o indicador de carregamento e mostrar o diálogo
        this.salvandoCronograma = false;
        this.cronogramaDialog = true;
        
        // Executar validação inicial após um pequeno delay
        this.$nextTick(() => {
          this.validarHorarios();
        });
      }
    },

    resetCronogramaForm() {
      this.cronogramaForm = {
        vsup: false,
        vsuc: false,
        vpra: false,
        horarioVpra: '00:00',
        horarioVsuc: '00:00',
        horarioVsup: '00:00',
        horarioVcon: '00:00',
        horarioVsyn: '00:00',
        logsVideo: false
      };
      
      // Limpar dados completos do cronograma
      this.cronogramaDataCompleto = null;
      
      // Limpar validações
      this.horariosConflitantes = [];
      this.temConflitosHorario = false;
    },

    async saveCronograma(formData) {
      try {
        const cronogramaData = {
          hostId: this.selectedHost.hostId, // Usar hostId (ID do Zabbix) em vez de id interno
          vsup: formData.vsup,
          vsuc: formData.vsuc,
          vpra: formData.vpra,
          vcon: formData.vcon,
          vsyn: formData.vsyn,
          horarioVpra: formData.horarioVpra,
          horarioVsuc: formData.horarioVsuc,
          horarioVsup: formData.horarioVsup,
          horarioVcon: formData.horarioVcon,
          horarioVsyn: formData.horarioVsyn,
          logsVideo: formData.logsVideo
        };

        const response = await hostsService.createOrUpdateCronograma(cronogramaData);
        
        // Verificar se a resposta inclui o campo success
        if (response && response.success === false) {
          throw new Error(response.message || 'Erro ao salvar cronograma');
        }
        
        this.showSnackbar('Cronograma salvo com sucesso', 'success');
        this.cronogramaDialog = false;
      } catch (error) {
        console.error('Erro ao salvar cronograma:', error);
        
        // Verificar se é erro de bloqueio de porta
        if (error.response && error.response.status === 403 && error.response.data.bloqueado) {
          this.showSnackbar(error.response.data.error || 'Este host possui bloqueio de porta, realize a liberação para poder configurar o cronograma.', 'error');
          return;
        }
        
        this.showSnackbar(error.message || 'Erro ao salvar cronograma', 'error');
      }
    },

    validarHorarios() {
      const validacao = HorarioValidator.validarHorarios(this.cronogramaForm);
      this.horariosConflitantes = validacao.conflitos.map(conflito => conflito.mensagem);
      this.temConflitosHorario = !validacao.valido;
    },

    async openAtualizacaoDialog(host) {
      this.selectedHost = host;
      
      // Verificar se há atualizações pendentes para este host
      try {
        const response = await hostsService.verificarAndamento(host.hostId);
        
        if (response && response.success) {
          if (response.emAndamento) {
            // Se há atualização em andamento, definir o sistema que está sendo atualizado
            this.atualizando = response.controle.sistema;
            this.showSnackbar(`Atualização do ${response.controle.sistema} em andamento. Botão bloqueado.`, 'info');
          } else {
            // Limpar estado de atualização se não há nada pendente
            this.atualizando = null;
          }
        }
      } catch (error) {
        console.error('[openAtualizacaoDialog] Erro ao verificar atualizações pendentes:', error);
        // Em caso de erro, limpar estado de atualização para permitir tentativas
        this.atualizando = null;
      }
      
      this.atualizacaoDialog = true;
    },

    fecharDialogAtualizacao() {
      if (this.atualizando) {
        // Permitir fechar mesmo com atualização em andamento, mas mostrar aviso
        this.showSnackbar(`Atualização do ${this.atualizando} em andamento. O progresso continuará em background.`, 'warning');
      }
      this.atualizacaoDialog = false;
      this.selectedHost = null;
      // Não limpar this.atualizando aqui, pois a atualização pode continuar em background
    },

    async openManualCronogramadoDialog(host) {
      this.selectedHost = host;
      this.manualCronogramadoSistema = null;
      this.manualCronogramadoHorario = null;
      this.agendamentosManuaisExistentes = [];
      this.templateValidationError = null;
      this.templatesVinculados = [];
      
      // Resetar formulário
      this.resetManualCronogramadoForm();
      
      // NOVO: Verificar se o host está vinculado ao templateID 12647
      try {
        const templateResponse = await hostsService.verificarTemplatePadronizacao(host.hostId);
        
        if (!templateResponse.hasTemplate) {
          // Host não está vinculado ao template requerido
          this.templateValidationError = 'Este host ainda não está vinculado ao template de Padronização de Atualização Automática.';
          this.templatesVinculados = templateResponse.templates;
          
          // Abrir diálogo mesmo assim para mostrar a mensagem
          this.manualCronogramadoDialog = true;
          return;
        }
        
        // Template válido, continuar normalmente
        this.templateValidationError = null;
        this.templatesVinculados = [];
      } catch (error) {
        console.error('Erro ao verificar template de padronização:', error);
        const errorMessage = error.response?.data?.error || error.message || 'Erro ao verificar template de padronização';
        this.showSnackbar(errorMessage, 'error');
        
        // Se for erro 404 (host não encontrado), não abrir o diálogo
        if (error.response && error.response.status === 404) {
          return;
        }
        
        // Para outros erros, abrir o diálogo mas mostrar aviso
        this.templateValidationError = errorMessage;
        this.manualCronogramadoDialog = true;
        return;
      }
      
      // Verificar se já existe um agendamento
      try {
        const response = await hostsService.getManualCronogramado(host.hostId);
        // Response agora é um array
        if (Array.isArray(response) && response.length > 0) {
          this.agendamentosManuaisExistentes = response;
        } else {
          this.agendamentosManuaisExistentes = [];
        }
      } catch (error) {
        // Se não encontrar (404), não há agendamento existente
        if (error.response && error.response.status !== 404) {
          console.error('Erro ao consultar agendamento manual cronogramado:', error);
          this.showSnackbar('Erro ao consultar agendamento existente', 'error');
        }
      }

      // Verificar se pode atualizar VSUP (regra: VSUC 8.04a ou superior)
      this.carregarPodeAtualizarVSUPManual(host);
      
      this.manualCronogramadoDialog = true;
    },

    async carregarPodeAtualizarVSUPManual(host) {
      if (!host || !host.hasVSUP || !host.hasVSUC) {
        this.podeAtualizarVSUPManual = true;
        this.mensagemBloqueioVSUPManual = '';
        return;
      }
      try {
        const res = await hostsService.podeAtualizarVSUP(host.hostId);
        if (res && res.success) {
          this.podeAtualizarVSUPManual = res.permitido;
          this.mensagemBloqueioVSUPManual = res.mensagem || '';
        } else {
          this.podeAtualizarVSUPManual = true;
          this.mensagemBloqueioVSUPManual = '';
        }
      } catch (e) {
        console.error('Erro ao verificar se pode atualizar VSUP:', e);
        this.podeAtualizarVSUPManual = true;
        this.mensagemBloqueioVSUPManual = '';
      }
    },

    fecharDialogManualCronogramado() {
      this.manualCronogramadoDialog = false;
      this.manualCronogramadoSistema = null;
      this.manualCronogramadoHorario = null;
      this.agendamentosManuaisExistentes = [];
      this.templateValidationError = null;
      this.templatesVinculados = [];
      this.podeAtualizarVSUPManual = true;
      this.mensagemBloqueioVSUPManual = '';
      this.resetManualCronogramadoForm();
    },
    
    resetManualCronogramadoForm() {
      this.manualCronogramadoForm = {
        vcon: false,
        vpra: false,
        vsuc: false,
        vsup: false,
        vsyn: false,
        horarioVcon: '',
        horarioVpra: '',
        horarioVsuc: '',
        horarioVsup: '',
        horarioVsyn: ''
      };
      this.horariosConflitantesManual = [];
      this.erroHorarioMinimo = null;
      this.erroHorarioMaximo = null;
      this.erroConflito10Minutos = null;
    },

    onSistemaManualCronogramadoChange(sistemaAtivado) {
      // Garantir que apenas um sistema esteja ativo por vez
      const sistemas = ['vcon', 'vpra', 'vsuc', 'vsup', 'vsyn'];
      
      sistemas.forEach(sistema => {
        if (sistema !== sistemaAtivado && this.manualCronogramadoForm[sistema]) {
          // Desmarcar outros sistemas e limpar seus horários
          this.manualCronogramadoForm[sistema] = false;
          const horarioField = `horario${sistema.charAt(0).toUpperCase() + sistema.slice(1)}`;
          this.manualCronogramadoForm[horarioField] = '';
        }
      });
      
      // Validar horários após mudança
      this.$nextTick(() => {
        this.validarHorariosManual();
      });
    },
    
    getIconeSistema(sistema) {
      const icones = {
        'VCON': '/ico_vcon.png',
        'VPRA': '/ico_vpra.png',
        'VSUC': '/ico_vsuc.png',
        'VSUP': '/ico_vsup.png',
        'VSYN': '/ico_vsyn.png'
      };
      return icones[sistema] || '/ico_default.png';
    },
    
    validarHorariosManual() {
      // Limpar erros anteriores
      this.erroHorarioMinimo = null;
      this.erroHorarioMaximo = null;
      this.erroConflito10Minutos = null;
      this.horariosConflitantesManual = [];
      
      if (!this.manualCronogramadoForm) return;
      
      const sistemas = [
        { key: 'vcon', nome: 'VCON', horario: 'horarioVcon' },
        { key: 'vpra', nome: 'VPRA', horario: 'horarioVpra' },
        { key: 'vsuc', nome: 'VSUC', horario: 'horarioVsuc' },
        { key: 'vsup', nome: 'VSUP', horario: 'horarioVsup' },
        { key: 'vsyn', nome: 'VSYN', horario: 'horarioVsyn' }
      ];
      
      // Encontrar o sistema selecionado (deve haver apenas um)
      const sistemaSelecionado = sistemas.find(sistema => 
        this.manualCronogramadoForm[sistema.key] && 
        this.manualCronogramadoForm[sistema.horario]
      );
      
      if (!sistemaSelecionado) return;
      
      const horario = this.manualCronogramadoForm[sistemaSelecionado.horario];
      
      // Validar formato básico
      const horarioRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
      if (!horarioRegex.test(horario)) {
        return; // Formato inválido, não mostrar erros específicos ainda
      }
      
      const agora = new Date();
      const [horas, minutos] = horario.split(':').map(Number);
      const horarioDate = new Date();
      horarioDate.setHours(horas, minutos, 0, 0);
      
      // Validar horário mínimo (07:30)
      const limiteMinimo = new Date();
      limiteMinimo.setHours(7, 30, 0, 0);
      if (horarioDate < limiteMinimo) {
        this.erroHorarioMinimo = `Horário deve ser a partir das 07:30`;
        return;
      }
      
      // Validar horário máximo (23:50)
      const limiteMaximo = new Date();
      limiteMaximo.setHours(23, 50, 0, 0);
      if (horarioDate > limiteMaximo) {
        this.erroHorarioMaximo = `Horário deve ser antes de 23:50`;
        return;
      }
      
      // Validar se é posterior à hora atual
      if (horarioDate <= agora) {
        // Não mostrar erro específico, apenas não permitir salvar
        return;
      }
      
      // Verificar conflito de 10 minutos com outros agendamentos
      // Isso será verificado no backend, mas podemos fazer uma validação básica aqui
      // se tivermos acesso aos outros agendamentos do cronograma
      // Por enquanto, deixamos o backend fazer essa validação
    },

    validarHorario(horario) {
      if (!horario) return 'Horário é obrigatório';
      
      const horarioRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
      if (!horarioRegex.test(horario)) {
        return 'Formato inválido. Use HH:MM (ex: 14:30)';
      }
      
      const agora = new Date();
      const [horas, minutos] = horario.split(':').map(Number);
      const horarioDate = new Date();
      horarioDate.setHours(horas, minutos, 0, 0);
      
      // Limite inicial: 07:30
      const limiteMinimo = new Date();
      limiteMinimo.setHours(7, 30, 0, 0);
      
      if (horarioDate < limiteMinimo) {
        return 'Horário deve ser a partir das 07:30';
      }
      
      // Limite máximo: 23:50
      const limiteMaximo = new Date();
      limiteMaximo.setHours(23, 50, 0, 0);
      if (horarioDate > limiteMaximo) {
        return 'Horário deve ser antes de 23:50';
      }
      
      // Limite secundário: deve ser após a hora atual
      if (horarioDate <= agora) {
        return 'Horário deve ser posterior à hora atual';
      }
      
      return true;
    },

    async salvarAgendamentoManual() {
      // Validar horários antes de salvar
      this.validarHorariosManual();
      
      if (this.horariosConflitantesManual.length > 0) {
        this.showSnackbar('Corrija os conflitos de horário antes de salvar', 'error');
        return;
      }
      
      if (!this.temSistemasAgendados) {
        this.showSnackbar('Selecione exatamente um sistema para agendar', 'error');
        return;
      }
      
      this.salvandoAgendamento = true;
      
      try {
        // Encontrar o sistema selecionado (apenas um deve estar selecionado)
        const sistemas = [
          { key: 'vcon', nome: 'VCON', horario: 'horarioVcon' },
          { key: 'vpra', nome: 'VPRA', horario: 'horarioVpra' },
          { key: 'vsuc', nome: 'VSUC', horario: 'horarioVsuc' },
          { key: 'vsup', nome: 'VSUP', horario: 'horarioVsup' },
          { key: 'vsyn', nome: 'VSYN', horario: 'horarioVsyn' }
        ];
        
        const sistemaSelecionado = sistemas.find(sistema => 
          this.manualCronogramadoForm[sistema.key] && 
          this.manualCronogramadoForm[sistema.horario]
        );
        
        if (!sistemaSelecionado) {
          this.showSnackbar('Nenhum sistema válido selecionado', 'error');
          return;
        }

        // VSUP: bloquear se VSUC não estiver em 8.04a ou superior
        if (sistemaSelecionado.nome === 'VSUP' && !this.podeAtualizarVSUPManual) {
          this.showSnackbar(this.mensagemBloqueioVSUPManual || 'Atualize o VSUC para 8.04a ou superior antes de agendar o VSUP.', 'error');
          return;
        }
        
        // Validar horário antes de enviar
        const validacao = this.validarHorario(this.manualCronogramadoForm[sistemaSelecionado.horario]);
        if (validacao !== true) {
          this.showSnackbar(validacao, 'error');
          return;
        }
        
        // VALIDAÇÃO: Verificar score de segurança antes de permitir agendamento manual cronogramado
        const versionFieldName = `${sistemaSelecionado.nome.toLowerCase()}Version`;
        const versaoAtual = this.selectedHost[versionFieldName];
        
        if (versaoAtual) {
          try {
            const sistemasParaValidar = [{ sistema: sistemaSelecionado.nome, versao: versaoAtual }];
            const response = await hostsService.calcularScoreSeguranca(sistemasParaValidar);
            
            if (response && response.success && response.scores) {
              const score = response.scores.find(s => s.sistema === sistemaSelecionado.nome);
              if (score && score.bloqueado) {
                let mensagem = '';
                if (score.versao_nao_encontrada) {
                  mensagem = `Agendamento bloqueado: O sistema ${sistemaSelecionado.nome} possui versão muito antiga (${score.versao_cliente}) que não existe no histórico.`;
                } else {
                  const versoesAtrasadas = score.versoes_atrasadas || 0;
                  mensagem = `Agendamento bloqueado: O sistema ${sistemaSelecionado.nome} está muito desatualizado (peso_total=${score.peso_total.toFixed(1)}, dias=${score.diferenca_dias}, versões atrasadas=${versoesAtrasadas}).`;
                }
                mensagem += ' Recomenda-se atualização manual.';
                
                this.showSnackbar(mensagem, 'error');
                return;
              }
            }
          } catch (scoreError) {
            console.error('Erro ao validar score de segurança:', scoreError);
            // Não bloquear se houver erro no cálculo do score, apenas logar
          }
        }
        
        // Criar agendamento (apenas um sistema)
        await hostsService.createManualCronogramado(
          this.selectedHost.hostId,
          sistemaSelecionado.nome,
          this.manualCronogramadoForm[sistemaSelecionado.horario]
        );
        
        this.showSnackbar(
          `Agendamento criado com sucesso: ${sistemaSelecionado.nome} às ${this.manualCronogramadoForm[sistemaSelecionado.horario]}`,
          'success'
        );
        
        // Recarregar agendamentos existentes e limpar formulário
        this.resetManualCronogramadoForm();
        try {
          const response = await hostsService.getManualCronogramado(this.selectedHost.hostId);
          // Response agora é um array
          if (Array.isArray(response) && response.length > 0) {
            this.agendamentosManuaisExistentes = response;
          } else {
            this.agendamentosManuaisExistentes = [];
          }
        } catch (error) {
          // Se não encontrar (404), não há agendamento existente
          if (error.response && error.response.status !== 404) {
            console.error('Erro ao recarregar agendamentos manuais cronogramados:', error);
          }
          this.agendamentosManuaisExistentes = [];
        }
      } catch (error) {
        console.error('Erro ao criar agendamento manual cronogramado:', error);
        
        // Tratar erros específicos do backend (preferir message quando existir, ex.: VSUP_BLOQUEADO_VSUC)
        const mensagem = error.response?.data?.message || error.response?.data?.error || error.message || 'Erro ao criar agendamento';
        
        // Verificar se é erro de conflito de 10 minutos
        if (mensagem.includes('10 minutos') || mensagem.includes('Conflitos de horário') || mensagem.includes('conflito')) {
          this.erroConflito10Minutos = mensagem;
        } else if (mensagem.includes('07:30') || mensagem.includes('mínimo') || mensagem.includes('a partir das')) {
          this.erroHorarioMinimo = mensagem;
        } else if (mensagem.includes('23:50') || mensagem.includes('máximo') || mensagem.includes('antes de')) {
          this.erroHorarioMaximo = mensagem;
        }
        
        this.showSnackbar(mensagem, 'error');
      } finally {
        this.salvandoAgendamento = false;
      }
    },

    async removerAgendamentoIndividual(sistema) {
      if (!this.agendamentosManuaisExistentes || this.agendamentosManuaisExistentes.length === 0) return;
      if (!this.selectedHost) return;
      
      this.removendoAgendamento = true;
      this.sistemaRemovendo = sistema;
      
      try {
        // Remover agendamento específico do sistema
        await hostsService.deleteManualCronogramado(this.selectedHost.hostId, sistema);
        this.showSnackbar(`Agendamento do sistema ${sistema} removido com sucesso`, 'success');
        
        // Recarregar lista de agendamentos
        try {
          const response = await hostsService.getManualCronogramado(this.selectedHost.hostId);
          if (Array.isArray(response) && response.length > 0) {
            this.agendamentosManuaisExistentes = response;
          } else {
            this.agendamentosManuaisExistentes = [];
          }
        } catch (error) {
          this.agendamentosManuaisExistentes = [];
        }
      } catch (error) {
        console.error('Erro ao remover agendamento manual cronogramado:', error);
        const mensagem = error.response?.data?.error || error.message || 'Erro ao remover agendamento';
        this.showSnackbar(mensagem, 'error');
      } finally {
        this.removendoAgendamento = false;
        this.sistemaRemovendo = null;
      }
    },

    formatarData(data) {
      if (!data) return '';
      // Se a data já está no formato YYYY-MM-DD, converter corretamente
      // para evitar problemas de timezone
      if (typeof data === 'string' && data.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
      }
      const date = new Date(data);
      // Usar UTC para evitar problemas de timezone
      const dia = String(date.getUTCDate()).padStart(2, '0');
      const mes = String(date.getUTCMonth() + 1).padStart(2, '0');
      const ano = date.getUTCFullYear();
      return `${dia}/${mes}/${ano}`;
    },

    async atualizarSistema(sistema) {
      try {
        this.atualizando = sistema;
        
        // Verifica se o ID do host é hostId ou id
        const hostId = this.selectedHost.hostId || this.selectedHost.id;
        
        // Obtém a versão atual do banco de dados antes da atualização
        const versionFieldName = `${sistema.toLowerCase()}Version`;
        const dbVersion = this.selectedHost[versionFieldName];
        const versaoAtual = this.selectedHost[versionFieldName];
        
        // VALIDAÇÃO: Verificar score de segurança antes de permitir atualização manual
        if (versaoAtual) {
          try {
            const sistemasParaValidar = [{ sistema: sistema, versao: versaoAtual }];
            const response = await hostsService.calcularScoreSeguranca(sistemasParaValidar);
            
            if (response && response.success && response.scores) {
              const score = response.scores.find(s => s.sistema === sistema);
              if (score && score.bloqueado) {
                let mensagem = '';
                if (score.versao_nao_encontrada) {
                  mensagem = `Atualização bloqueada: O sistema ${sistema} possui versão muito antiga (${score.versao_cliente}) que não existe no histórico.`;
                } else {
                  const versoesAtrasadas = score.versoes_atrasadas || 0;
                  mensagem = `Atualização bloqueada: O sistema ${sistema} está muito desatualizado (peso_total=${score.peso_total.toFixed(1)}, dias=${score.diferenca_dias}, versões atrasadas=${versoesAtrasadas}).`;
                }
                mensagem += ' Recomenda-se atualização manual.';
                
                this.showSnackbar(mensagem, 'error');
                this.atualizando = null;
                return;
              }
            }
          } catch (scoreError) {
            console.error('Erro ao validar score de segurança:', scoreError);
            // Não bloquear se houver erro no cálculo do score, apenas logar
          }
        }
        
        // Chamada à API para atualizar o sistema
        const resposta = await hostsService.atualizarSistema(hostId, sistema);
        
        // Verificar se o sistema já está atualizado (sem necessidade de verificação adicional)
        if (resposta.status === 'ALREADY_UPDATED') {
          this.showSnackbar(`Sistema ${sistema} já está atualizado para a versão ${resposta.newVersion}!`, 'info');
          
          // Atualiza a lista de hosts
          await this.fetchHosts();
          
          // Marca como não mais atualizando e encerra
          this.atualizando = null;
          
          // Fecha o diálogo de atualização
          this.atualizacaoDialog = false;
          
          return;
        }
        
        // Mostrar mensagem de início da atualização
        this.showSnackbar(`Iniciando atualização do ${sistema}...`, 'info');
        
        // Iniciar verificação da atualização
        try {
          // Mostrar mensagem de espera
          this.showSnackbar(`Aguardando confirmação da atualização do ${sistema}...`, 'info');
          
          // O backend já está fazendo a verificação via updateChecker
          // Não precisamos fazer verificação adicional no frontend
          // Apenas aguardamos o resultado via WebSocket ou atualizamos a lista periodicamente
          
          // COMENTADO: Polling que estava causando spam de requisições
          // Atualizar a lista de hosts periodicamente para mostrar progresso
          // let pollCount = 0;
          // const maxPolls = 12; // 12 * 30 segundos = 6 minutos
          
          // const pollHosts = async () => {
          //   if (pollCount < maxPolls && this.atualizando === sistema) {
          //     await this.fetchHosts();
          //     pollCount++;
          //     
          //     // Verificar se a atualização foi concluída
          //     const updatedHost = this.hosts.find(h => h.hostId === hostId);
          //     if (updatedHost) {
          //       const currentVersion = updatedHost[`${sistema.toLowerCase()}Version`];
          //       if (currentVersion === dbVersion) {
          //         this.showSnackbar(`${sistema} atualizado com sucesso! Nova versão: ${currentVersion}`, 'success');
          //         this.atualizando = null;
          //         this.atualizacaoDialog = false;
          //         return;
          //       }
          //     }
          //     
          //     // Continuar polling se ainda não terminou
          //     if (this.atualizando === sistema) {
          //       setTimeout(pollHosts, 30000); // 30 segundos
          //     }
          //   } else if (this.atualizando === sistema) {
          //     // Timeout - parar de verificar mas não mostrar erro
          //     this.showSnackbar(`Verificação de atualização do ${sistema} finalizada. Verifique manualmente se necessário.`, 'info');
          //     this.atualizando = null;
          //   }
          // };
          
          // COMENTADO: Iniciar o polling após 30 segundos
          // setTimeout(pollHosts, 30000);
          
          // Em vez do polling, vamos confiar no WebSocket e na verificação manual
          this.showSnackbar(`Atualização do ${sistema} iniciada. Use o WebSocket ou atualize manualmente para verificar o progresso.`, 'info');
          
        } catch (erroVerificacao) {
          console.error('Erro ao iniciar verificação:', erroVerificacao);
          this.showSnackbar(`Erro ao verificar atualização: ${erroVerificacao.message}`, 'warning');
        }
        
        // Atualiza a lista de hosts após a atualização inicial
        await this.fetchHosts();
        
      } catch (error) {
        console.error(`Erro ao atualizar ${sistema}:`, error);
        this.showSnackbar(`Erro ao atualizar ${sistema}: ${error.message}`, 'error');
        this.atualizando = null;
      }
    },

    showNotImplemented() {
      if (this.selectedHost) {
        this.openAtualizacaoDialog(this.selectedHost);
      }
    },

    showSnackbar(text, color = 'info') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    hasSystem(item, sistema) {
      if (!item || !sistema) {
        return false;
      }
      const key = `has${sistema}`;
      return Boolean(item[key]);
    },

    getSystemVersion(item, sistema) {
      if (!item || !sistema) {
        return null;
      }
      const key = `${sistema.toLowerCase()}Version`;
      return item[key] ?? null;
    },

    getSystemSize(item, sistema) {
      if (!item || !sistema) {
        return null;
      }
      const key = `${sistema.toLowerCase()}Size`;
      return item[key] ?? null;
    },

    getSystemContainerClasses(item, sistema) {
      const has = this.hasSystem(item, sistema);

      if (!has) {
        return ['status-unavailable'];
      }

      const isUpdated = this.isSystemUpdated(this.getSystemVersion(item, sistema), sistema);

      if (isUpdated) {
        return ['status-updated', 'updated'];
      }

      const classes = ['status-outdated', 'outdated'];

      if (this.isDatabaseSizeBlockedForItem(item, sistema)) {
        classes.push('status-blocked');
      }

      return classes;
    },

    isSystemUpdated(currentVersion, sistema) {
      if (!this.versionsLoaded || !currentVersion || !this.latestVersions[sistema]) {
        return false;
      }
      
      // Vamos comparar as versões
      return currentVersion === this.latestVersions[sistema];
    },

    getSystemVersionTooltip(version, sistema) {
      if (!this.versionsLoaded) {
        return `Versão atual: ${version}`;
      }
      
      const latestVersion = this.latestVersions[sistema];
      
      if (!latestVersion) {
        return `Versão atual: ${version}`;
      }
      
      if (version === latestVersion) {
        return `Versão ${version} (Atualizada)`;
      } else {
        return `Versão ${version} (Desatualizada - versão atual: ${latestVersion})`;
      }
    },

    async loadSystemVersions() {
      // Prevenir chamadas duplicadas
      if (this.systemVersionsCarregando) {
        return;
      }
      
      this.systemVersionsCarregando = true;
      try {
        const response = await hostsService.getSystemVersions();
        
        // Verificar se a resposta inclui o campo success
        if (response && response.success === false) {
          throw new Error(response.message || 'Erro ao carregar versões dos sistemas');
        }
        
        if (response.versions) {
          this.latestVersions = response.versions;
          this.versionsLoaded = true;
          
          // Aplicar filtro de hosts novamente com as versões atualizadas
          this.filtrarHosts();
        } else {
          throw new Error('Erro ao carregar versões: formato de resposta inválido');
        }
      } catch (error) {
        console.error('Erro ao carregar versões dos sistemas:', error);
        this.showSnackbar('Não foi possível carregar as versões mais recentes dos sistemas', 'warning');
      } finally {
        this.systemVersionsCarregando = false;
      }
    },

    async loadMacroMasterVersion() {
      try {
        const response = await hostsService.getMacroMasterVersion();
        
        // Verificar se a resposta inclui o campo success
        if (response && response.success === false) {
          throw new Error(response.message || 'Erro ao carregar versão do MacroMaster');
        }
        
        // O interceptor do axios retorna response.data, então a estrutura é:
        // response = { success: true, data: { version: ... } }
        // ou response = { data: { version: ... } }
        let version = null;
        
        if (response.data && response.data.version) {
          // Estrutura: { success: true, data: { version: ... } }
          version = response.data.version;
        } else if (response.version) {
          // Estrutura direta: { version: ... }
          version = response.version;
        } else if (typeof response === 'string') {
          // Se a resposta for diretamente uma string
          version = response;
        }
        
        if (version && typeof version === 'string' && version.trim() !== '') {
          this.macromasterVersion = version.trim();
          this.macromasterLoaded = true;
        } else {
          throw new Error('Erro ao carregar versão do MacroMaster: formato de resposta inválido');
        }
      } catch (error) {
        console.error('Erro ao carregar versão do MacroMaster:', error);
        this.macromasterVersion = null;
        this.macromasterLoaded = false;
        this.showSnackbar('Não foi possível carregar a versão do MacroMaster', 'warning');
      }
    },

    // Formatar o hash do MacroMaster (primeiros 8 caracteres)
    formatMacroMasterHash(hash) {
      if (!hash || hash === null || hash === undefined) {
        return 'N/A';
      }
      
      // Garantir que é uma string
      const hashString = String(hash).trim();
      
      if (hashString.length === 0) {
        return 'N/A';
      }
      
      // Retornar primeiros 8 caracteres
      return hashString.substring(0, 8);
    },

    // Determinar a cor do chip do MacroMaster
    getMacroMasterChipColor(hostMacromasterVersion) {
      if (!hostMacromasterVersion || !this.macromasterLoaded || !this.macromasterVersion) {
        return 'grey';
      }
      
      // Comparar apenas os primeiros 8 caracteres (já que exibimos apenas 8)
      const host8Chars = hostMacromasterVersion.substring(0, 8);
      const master8Chars = this.macromasterVersion.substring(0, 8);
      
      return host8Chars === master8Chars ? 'success' : 'error';
    },
    
    // Método auxiliar apenas para recompilação
    recompileHelper() {
      return true;
    },

    // Método auxiliar para filtrar um array específico de hosts
    filtrarHostsArray(hostsArray) {
      let hostsParaFiltrar = [...hostsArray];
      
      // Aplicar os mesmos filtros do método filtrarHosts
      
      // Filtro base: mostrar todos os hosts ou apenas os que têm sistemas
      if (!this.mostrarTodosHosts) {
        hostsParaFiltrar = hostsParaFiltrar.filter(host => host.hasVCON || host.hasVPRA || host.hasVSUC || host.hasVSUP || host.hasVSYN);
      }
      
      // Filtro por sistemas específicos
      if (this.filtroSistemas && this.filtroSistemas.length > 0) {
        hostsParaFiltrar = hostsParaFiltrar.filter(host => {
          return this.filtroSistemas.some(sistema => {
            switch (sistema) {
              case 'VCON':
                return host.hasVCON;
              case 'VPRA':
                return host.hasVPRA;
              case 'VSUC':
                return host.hasVSUC;
              case 'VSUP':
                return host.hasVSUP;
              case 'VSYN':
                return host.hasVSYN;
              default:
                return false;
            }
          });
        });
      }
      
      // Filtro por status de atualização
      if (this.filtroStatusAtualizacao) {
        hostsParaFiltrar = hostsParaFiltrar.filter(host => {
          // Se há filtro de sistemas, verificar apenas os sistemas filtrados
          // Se não há filtro de sistemas, verificar todos os sistemas do host
          const sistemasParaVerificar = [];
          
          if (this.filtroSistemas && this.filtroSistemas.length > 0) {
            // Verificar apenas os sistemas que estão no filtro
            this.filtroSistemas.forEach(sistema => {
              switch (sistema) {
                case 'VCON':
                  if (host.hasVCON) sistemasParaVerificar.push({ nome: 'VCON', versao: host.vconVersion });
                  break;
                case 'VPRA':
                  if (host.hasVPRA) sistemasParaVerificar.push({ nome: 'VPRA', versao: host.vpraVersion });
                  break;
                case 'VSUC':
                  if (host.hasVSUC) sistemasParaVerificar.push({ nome: 'VSUC', versao: host.vsucVersion });
                  break;
                case 'VSUP':
                  if (host.hasVSUP) sistemasParaVerificar.push({ nome: 'VSUP', versao: host.vsupVersion });
                  break;
                case 'VSYN':
                  if (host.hasVSYN) sistemasParaVerificar.push({ nome: 'VSYN', versao: host.vsynVersion });
                  break;
              }
            });
          } else {
            // Se não há filtro de sistemas, verificar todos os sistemas do host
            if (host.hasVCON) sistemasParaVerificar.push({ nome: 'VCON', versao: host.vconVersion });
            if (host.hasVPRA) sistemasParaVerificar.push({ nome: 'VPRA', versao: host.vpraVersion });
            if (host.hasVSUC) sistemasParaVerificar.push({ nome: 'VSUC', versao: host.vsucVersion });
            if (host.hasVSUP) sistemasParaVerificar.push({ nome: 'VSUP', versao: host.vsupVersion });
            if (host.hasVSYN) sistemasParaVerificar.push({ nome: 'VSYN', versao: host.vsynVersion });
          }
          
          if (sistemasParaVerificar.length === 0) return false;
          
          // Verificar se pelo menos um dos sistemas verificados corresponde ao filtro de status
          return sistemasParaVerificar.some(sistema => {
            const estaAtualizado = this.isSystemUpdated(sistema.versao, sistema.nome);
            
            if (this.filtroStatusAtualizacao === 'atualizado') {
              return estaAtualizado;
            } else if (this.filtroStatusAtualizacao === 'desatualizado') {
              return !estaAtualizado;
            }
            
            return true;
          });
        });
      }
      
      // Filtro por MacroMaster
      if (this.filtroMacroMaster !== null) {
        hostsParaFiltrar = hostsParaFiltrar.filter(host => {
          const temMacroMaster = !!(host.macromasterVersion && host.macromasterVersion !== null && host.macromasterVersion !== '');
          
          if (this.filtroMacroMaster === 'com') {
            // Filtrar apenas hosts COM MacroMaster (qualquer versão)
            return temMacroMaster;
          } else if (this.filtroMacroMaster === 'atualizado') {
            // Filtrar apenas hosts COM MacroMaster ATUALIZADO
            if (!temMacroMaster) return false; // Precisa ter MacroMaster primeiro
            if (!this.macromasterLoaded || !this.macromasterVersion) return false; // Versão master precisa estar carregada
            
            // Comparar primeiros 8 caracteres (mesma lógica do getMacroMasterChipColor)
            const host8Chars = host.macromasterVersion.substring(0, 8);
            const master8Chars = this.macromasterVersion.substring(0, 8);
            return host8Chars === master8Chars;
          } else if (this.filtroMacroMaster === 'desatualizado') {
            // Filtrar apenas hosts COM MacroMaster DESATUALIZADO
            if (!temMacroMaster) return false; // Precisa ter MacroMaster primeiro
            if (!this.macromasterLoaded || !this.macromasterVersion) return false; // Versão master precisa estar carregada
            
            // Comparar primeiros 8 caracteres (mesma lógica do getMacroMasterChipColor)
            const host8Chars = host.macromasterVersion.substring(0, 8);
            const master8Chars = this.macromasterVersion.substring(0, 8);
            return host8Chars !== master8Chars;
          } else if (this.filtroMacroMaster === 'sem') {
            // Filtrar apenas hosts SEM MacroMaster
            return !temMacroMaster;
          }
          
          return true;
        });
      }
      
      // Filtro por Cronograma
      if (this.filtroCronograma !== null) {
        hostsParaFiltrar = hostsParaFiltrar.filter(host => {
          const temCronograma = host.tem_cronograma === true || host.tem_cronograma === 'true';
          if (this.filtroCronograma === 'com') return temCronograma;
          if (this.filtroCronograma === 'sem') return !temCronograma;
          return true;
        });
      }
      
      // Filtro por Base Size (tamanho da base de dados)
      if (this.filtros.baseSizeMin !== null || this.filtros.baseSizeMax !== null) {
        hostsParaFiltrar = hostsParaFiltrar.filter(host => {
          // Obter o maior tamanho de base entre todos os sistemas do host
          const tamanhosBase = [];
          if (host.vconSize) tamanhosBase.push(this.parseSizeValue(host.vconSize));
          if (host.vpraSize) tamanhosBase.push(this.parseSizeValue(host.vpraSize));
          if (host.vsucSize) tamanhosBase.push(this.parseSizeValue(host.vsucSize));
          if (host.vsupSize) tamanhosBase.push(this.parseSizeValue(host.vsupSize));
          if (host.vsynSize) tamanhosBase.push(this.parseSizeValue(host.vsynSize));
          
          if (tamanhosBase.length === 0) {
            // Se o host não tem nenhum tamanho de base, não aplicar o filtro (ou filtrar fora, dependendo da lógica)
            return false; // Ou true, dependendo do comportamento desejado
          }
          
          const maiorTamanho = Math.max(...tamanhosBase);
          
          // Aplicar filtros de min e max
          const minValue = this.filtros.baseSizeMin !== null ? this.filtros.baseSizeMin : this.baseSizeRange.min;
          const maxValue = this.filtros.baseSizeMax !== null ? this.filtros.baseSizeMax : this.baseSizeRange.max;
          
          return maiorTamanho >= minValue && maiorTamanho <= maxValue;
        });
      }
      
      return hostsParaFiltrar;
    },

    filtrarHosts() {
      // Resetar paginação quando filtros mudarem
      this.pagination.page = 1;
      
      // Aplicar filtros nos hosts já carregados usando o método auxiliar
      const hostsFiltrados = this.filtrarHostsArray(this.hosts);
      this.filteredHosts = hostsFiltrados;
    },
    
    // Método para obter filtros formatados para enviar ao backend
    getFiltersForBackend() {
      const filters = {};
      
      // Filtro de sistemas
      if (this.filtroSistemas && this.filtroSistemas.length > 0) {
        filters.sistemas = this.filtroSistemas;
      }
      
      // Filtro de status de atualização
      if (this.filtroStatusAtualizacao) {
        filters.statusAtualizacao = this.filtroStatusAtualizacao;
      }
      
      // Filtro de MacroMaster
      if (this.filtroMacroMaster) {
        filters.macroMaster = this.filtroMacroMaster;
        // Incluir versão do MacroMaster se disponível
        if (this.macromasterVersion) {
          filters.macroMasterVersion = this.macromasterVersion;
        }
      }
      
      // Filtro de Cronograma
      if (this.filtroCronograma) {
        filters.temCronograma = this.filtroCronograma;
      }
      
      return filters;
    },
    
    // Método para aplicar filtros no backend
    async aplicarFiltros() {
      this.aplicandoFiltros = true;
      this.loading = true;
      
      try {
        // Resetar estado de paginação e scroll infinito
        this.pagination.page = 1;
        this.currentPage = 1;
        this.allHostsLoaded = false;
        this.hosts = [];
        this.filteredHosts = [];
        this.allFilteredHosts = []; // Limpar hosts filtrados armazenados
        this.hostsDisplayedCount = 0; // Resetar contador de hosts exibidos
        
        // Remover listeners de scroll infinito
        this.removeScrollListener();
        this.removeIntersectionObserver();
        
        // Obter filtros formatados
        const filters = this.getFiltersForBackend();
        
        // Incluir o campo de pesquisa se houver valor
        const searchValue = this.search && this.search.trim() !== '' ? this.search.trim() : '';
        
        // Buscar TODOS os hosts de uma vez (sem paginação) quando há filtros
        let response;
        if (typeof hostsService.listHosts === 'function') {
          response = await hostsService.listHosts(1, 20, true, searchValue, filters);
        } else {
          throw new Error('hostsService.listHosts não está disponível');
        }
        
        // Verificar se a resposta inclui o campo success
        if (response && response.success === false) {
          throw new Error(response.message || 'Erro ao buscar hosts');
        }
        
        // Verificar se hosts existe na resposta
        if (!response || !response.hosts || !Array.isArray(response.hosts)) {
          throw new Error('Resposta da API não contém lista de hosts válida');
        }
        
        // Processar hosts recebidos
        const uniqueHosts = Array.from(new Map(response.hosts.map(host => [host.hostId, host])).values());
        
        // Atualizar informações de paginação
        this.totalHosts = response.totalHostsCount || uniqueHosts.length;
        this.pagination.serverItemsLength = this.totalHosts;
        
        // Armazenar todos os hosts retornados (já foram buscados todos de uma vez)
        this.hosts = uniqueHosts;
        
        // Recarregar as versões dos sistemas
        if (!this.versionsLoaded) {
          await this.loadSystemVersions();
        }
        
        // Aplicar filtro de hosts (filtros do frontend) - obter todos os hosts filtrados
        const allFiltered = this.filtrarHostsArray(uniqueHosts);
        this.allFilteredHosts = allFiltered; // Armazenar todos os hosts filtrados
        
        // Se retornou mais de 20 hosts, mostrar apenas os primeiros 20 inicialmente
        // e usar scroll infinito para mostrar o restante progressivamente
        if (allFiltered.length > 20) {
          // Mostrar apenas os primeiros 20
          this.hostsDisplayedCount = 20;
          this.filteredHosts = allFiltered.slice(0, 20);
          this.allHostsLoaded = false; // Ainda há mais hosts para mostrar
          
          // Configurar scroll infinito para mostrar mais hosts progressivamente
          this.$nextTick(() => {
            if (this.showAllMode) {
              this.setupScrollListener();
              this.setupIntersectionObserver();
            }
          });
        } else {
          // Se retornou 20 ou menos, mostrar todos
          this.hostsDisplayedCount = allFiltered.length;
          this.filteredHosts = allFiltered;
          this.allHostsLoaded = true; // Todos foram exibidos
        }
        
        // Forçar altura da tabela após carregar dados
        if (this.heightCalculationTimeout) {
          clearTimeout(this.heightCalculationTimeout);
        }
        this.heightCalculationTimeout = setTimeout(() => {
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              this.calculateAvailableHeight();
            });
          });
        }, 300);
        
        this.showSnackbar('Filtros aplicados com sucesso', 'success');
      } catch (error) {
        console.error('[aplicarFiltros] Erro ao aplicar filtros:', error);
        this.showSnackbar('Erro ao aplicar filtros', 'error');
      } finally {
        this.aplicandoFiltros = false;
        this.loading = false;
      }
    },

    isAtualizado(sistema) {
      return this.isSystemUpdated(this.selectedHost[`${sistema.toLowerCase()}Version`], sistema);
    },

    // Retorna a chave do item Zabbix para cada sistema
    getItemKeyForSystem(sistema) {
      switch (sistema.toUpperCase()) {
        case 'VCON':
          return 'connect.map.version';
        case 'VPRA':
          return 'practice.map.version';
        case 'VSUC':
          return 'success.map.version';
        case 'VSUP':
          return 'supply.map.version';
        case 'VSYN':
          return 'sync.map.version';
        default:
          return `${sistema.toLowerCase()}.map.version`;
      }
    },

    // Método para atualizar sistema sem verificação do Zabbix
    async atualizarSistemaSemVerificacao(sistema) {
      try {
        this.atualizandoSemVerificacao = sistema;
        
        // Verifica se o ID do host é hostId ou id
        const hostId = this.selectedHost.hostId || this.selectedHost.id;
        
        // Obtém a versão atual do banco de dados antes da atualização
        const versionFieldName = `${sistema.toLowerCase()}Version`;
        const dbVersion = this.selectedHost[versionFieldName];
        
        // Chamada à API para atualizar o sistema
        const resposta = await hostsService.atualizarSistema(hostId, sistema);
        
        // Verificar se o sistema já está atualizado (sem necessidade de verificação adicional)
        if (resposta.status === 'ALREADY_UPDATED') {
          this.showSnackbar(`Sistema ${sistema} já está atualizado para a versão ${resposta.newVersion}!`, 'info');
          
          // Atualiza a lista de hosts
          await this.fetchHosts();
          
          // Marca como não mais atualizando e encerra
          this.atualizandoSemVerificacao = null;
          
          // Fecha o diálogo de atualização
          this.atualizacaoDialog = false;
          
          return;
        }
        
        if (resposta && resposta.success) {
          // Aqui não fazemos a verificação posterior no Zabbix
          this.showSnackbar(`Macro de atualização do ${sistema} executada com sucesso! A sessão RDP permanece ativa.`, 'success');
          
          // Atualiza a lista de hosts após a atualização inicial
          await this.fetchHosts();
          
          // Marca como não mais atualizando e encerra
          this.atualizandoSemVerificacao = null;
        } else {
          this.showSnackbar(`Erro ao atualizar ${sistema}: ${resposta.message || 'Erro desconhecido'}`, 'error');
          this.atualizandoSemVerificacao = null;
        }
        
      } catch (error) {
        console.error(`Erro ao atualizar ${sistema}:`, error);
        this.showSnackbar(`Erro ao atualizar ${sistema}: ${error.message}`, 'error');
        this.atualizandoSemVerificacao = null;
      }
    },

    async syncSingleHost(host) {
      this.$set(host, 'syncing', true);
      try {
        const response = await hostsService.syncSingleHost(host.hostId);
        
        if (response && response.success) {
          // Atualiza apenas o host na lista
          const updatedHost = response.host;
          
          const idx = this.hosts.findIndex(h => h.hostId === updatedHost.hostId);
          
          if (idx !== -1) {
            this.$set(this.hosts, idx, updatedHost);
            this.filtrarHosts();
          }
          
          await this.loadSystemVersions();
          
          this.showSnackbar(`Host ${updatedHost.name} sincronizado com sucesso!`, 'success');
        } else {
          this.showSnackbar((response && response.message) ? response.message : 'Erro ao sincronizar host', 'error');
        }
      } catch (error) {
        console.error('[syncSingleHost] Erro ao sincronizar host:', error);
        this.showSnackbar((error && error.message) ? error.message : 'Erro ao sincronizar host', 'error');
      } finally {
        this.$set(host, 'syncing', false);
      }
    },

    async onAtualizacaoConcluida(dadosAtualizacao) {
      const hostIdAfetado = dadosAtualizacao.hostId;
      const sistemaAfetado = dadosAtualizacao.sistema; // Pode ser útil para lógica futura

      try {
        if (hostIdAfetado) {
          const hostNaLista = this.hosts.find(h => (h.hostId === hostIdAfetado || h.id === hostIdAfetado));
          
          if (hostNaLista) {
            // Chamar syncSingleHost para atualizar apenas este host.
            // syncSingleHost já lida com a atualização na lista this.hosts e recarrega as versões do sistema.
            await this.syncSingleHost(hostNaLista); 
          } else {
            // Host não encontrado na lista, pode ser um novo host ou um caso inesperado.
            // Recarregar tudo como fallback.
            await this.loadSystemVersions();
            await this.fetchHosts();
          }
        } else {
          // Se não houver hostId específico nos dados da atualização, recarregar tudo como antes.
          await this.loadSystemVersions();
          await this.fetchHosts();
        }

        // Lógica para fechar o diálogo de atualização
        if (this.atualizacaoDialog && this.selectedHost &&
            (this.selectedHost.hostId === hostIdAfetado || this.selectedHost.id === hostIdAfetado) &&
            this.atualizando === sistemaAfetado) {
          this.atualizando = null;
          this.atualizacaoDialog = false;
        } else if (this.atualizando === sistemaAfetado) {
          // Se não está no diálogo mas o sistema estava sendo atualizado, limpar o estado
          this.atualizando = null;
        }
      } catch (error) {
        console.error('[onAtualizacaoConcluida] Erro ao processar conclusão da atualização:', error);
        // Fallback em caso de erro durante a atualização seletiva, recarrega tudo
        try {
          await this.loadSystemVersions();
          await this.fetchHosts();
        } catch (fallbackError) {
          console.error('[onAtualizacaoConcluida] Erro no fallback de fetchHosts:', fallbackError);
        }
      }
    },

    async onVersaoAtualizada(dadosVersao) {
      const hostIdAfetado = dadosVersao.hostId;
      const sistemaAfetado = dadosVersao.sistema;
      const novaVersao = dadosVersao.novaVersao;

      try {
        if (hostIdAfetado) {
          const hostNaLista = this.hosts.find(h => (h.hostId === hostIdAfetado || h.id === hostIdAfetado));
          
          if (hostNaLista) {
            // Atualizar a versão do sistema específico no host
            const versionField = `${sistemaAfetado.toLowerCase()}Version`;
            hostNaLista[versionField] = novaVersao;
            
            // Forçar atualização da interface
            this.$forceUpdate();
          } else {
            // Host não encontrado na lista, recarregar tudo como fallback
            await this.loadSystemVersions();
            await this.fetchHosts();
          }
        } else {
          // Se não houver hostId específico, recarregar tudo
          await this.loadSystemVersions();
          await this.fetchHosts();
        }
      } catch (error) {
        console.error('[onVersaoAtualizada] Erro ao processar atualização de versão:', error);
        // Fallback em caso de erro
        try {
          await this.loadSystemVersions();
          await this.fetchHosts();
        } catch (fallbackError) {
          console.error('[onVersaoAtualizada] Erro no fallback de fetchHosts:', fallbackError);
        }
      }
    },

    async openLogsDialog(host) {
      this.selectedHost = host;
      this.logsDialog = true;
    },

    redirectToLogin() {
      this.$router.push('/login');
    },

    formatDate(date) {
      const formattedDate = new Date(date).toLocaleString();
      return formattedDate.replace(',', ' às');
    },


    // Método auxiliar para verificar se a base de dados excede o limite configurado
    isDatabaseSizeBlocked(sistema) {
      if (!this.selectedHost) {
        return false;
      }
      
      return this.isDatabaseSizeBlockedForItem(this.selectedHost, sistema);
    },

    // Método auxiliar para verificar se a base de dados de um item específico excede o limite
    isDatabaseSizeBlockedForItem(item, sistema) {
      if (!item) {
        return false;
      }
      
      const sizeFieldName = `${sistema.toLowerCase()}Size`;
      const sizeValue = item[sizeFieldName];
      
      if (!sizeValue || sizeValue === null || sizeValue === undefined) {
        return false;
      }
      
      // Converter o valor para número (remover qualquer formatação extra)
      let sizeNumber;
      if (typeof sizeValue === 'string') {
        // Remove espaços, "GB" e outros caracteres não numéricos, exceto ponto e vírgula
        const cleanValue = sizeValue.toString().replace(/[^\d.,]/g, '').replace(',', '.');
        sizeNumber = parseFloat(cleanValue);
      } else {
        sizeNumber = parseFloat(sizeValue);
      }
      
      if (isNaN(sizeNumber)) {
        return false;
      }
      
      // Bloquear se for maior que o limite configurado (do banco de dados)
      // Se não houver limite configurado (0), não bloquear
      if (this.databaseSizeLimitGB === 0) {
        return false;
      }
      
      const isBlocked = sizeNumber > this.databaseSizeLimitGB;
      
      return isBlocked;
    },

    // Formatar o tamanho da base de dados para exibição
    formatDatabaseSize(size) {
      if (!size || size === null || size === undefined) {
        return 'N/A';
      }
      
      let sizeNumber;
      if (typeof size === 'string') {
        // Remove espaços, "GB" e outros caracteres não numéricos, exceto ponto e vírgula
        const cleanValue = size.toString().replace(/[^\d.,]/g, '').replace(',', '.');
        sizeNumber = parseFloat(cleanValue);
      } else {
        sizeNumber = parseFloat(size);
      }
      
      if (isNaN(sizeNumber)) {
        return 'N/A';
      }
      
      return `${sizeNumber} GB`;
    },

    // Obter tooltip para o bloqueio de atualização
    getUpdateBlockTooltip(sistema) {
      if (!this.isDatabaseSizeBlocked(sistema)) return '';
      
      const sizeFieldName = `${sistema.toLowerCase()}Size`;
      const sizeValue = this.selectedHost[sizeFieldName];
      
      return `Atualização manual bloqueada: Base de dados muito grande (${this.formatDatabaseSize(sizeValue)}). Use o cronograma para atualizações automáticas.`;
    },

    async limparFiltros() {
      this.filtroSistemas = [];
      this.filtroStatusAtualizacao = null;
      this.filtroMacroMaster = null;
      this.filtroCronograma = null;
      this.filtros.baseSizeMin = null;
      this.filtros.baseSizeMax = null;
      this.baseSizeSliderValue = [this.baseSizeRange.min, this.baseSizeRange.max];
      
      // Resetar estado de paginação e scroll infinito
      this.pagination.page = 1;
      this.currentPage = 1;
      this.allHostsLoaded = false;
      this.hosts = [];
      this.filteredHosts = [];
      this.allFilteredHosts = []; // Limpar hosts filtrados armazenados
      this.hostsDisplayedCount = 0; // Resetar contador de hosts exibidos
      
      // Remover listeners de scroll infinito
      this.removeScrollListener();
      this.removeIntersectionObserver();
      
      // Recarregar hosts sem filtros (comportamento normal de paginação)
      await this.fetchHosts(true, false, null);
      
      // Se estiver no modo All, reativar scroll infinito
      this.$nextTick(() => {
        if (this.showAllMode && this.hosts.length >= 20 && !this.allHostsLoaded) {
          this.setupScrollListener();
          this.setupIntersectionObserver();
        }
      });
    },
    
    // Métodos relacionados ao filtro de base_size
    async buscarBaseSizeRange() {
      this.loadingBaseSizeRange = true;
      try {
        const response = await dashboardService.getBaseSizeRange();
        
        if (response.success && response.range) {
          this.baseSizeRange = response.range;
          // Inicializar o slider com os valores do range
          this.baseSizeSliderValue = [this.baseSizeRange.min, this.baseSizeRange.max];
          // Inicializar os filtros com os valores mínimo e máximo
          if (this.filtros.baseSizeMin === null || this.filtros.baseSizeMin === undefined) {
            this.filtros.baseSizeMin = this.baseSizeRange.min;
          }
          if (this.filtros.baseSizeMax === null || this.filtros.baseSizeMax === undefined) {
            this.filtros.baseSizeMax = this.baseSizeRange.max;
          }
        }
      } catch (error) {
        console.error('Erro ao buscar range de base_size:', error);
        // Manter valores padrão em caso de erro
      } finally {
        this.loadingBaseSizeRange = false;
      }
    },
    
    /**
     * Atualiza os filtros em tempo real enquanto arrasta o slider (sem aplicar filtros)
     */
    updateBaseSizeFiltersRealTime(sliderValue) {
      if (sliderValue && Array.isArray(sliderValue) && sliderValue.length === 2) {
        // Arredondar para 1 casa decimal
        const minValue = Math.round(sliderValue[0] * 10) / 10;
        const maxValue = Math.round(sliderValue[1] * 10) / 10;
        
        // Atualizar apenas os valores visuais (não aplicar filtros ainda)
        if (minValue === this.baseSizeRange.min && maxValue === this.baseSizeRange.max) {
          this.filtros.baseSizeMin = null;
          this.filtros.baseSizeMax = null;
        } else {
          this.filtros.baseSizeMin = minValue;
          this.filtros.baseSizeMax = maxValue;
        }
      }
    },
    
    /**
     * Atualiza os filtros quando o slider para de ser arrastado (aplica filtros)
     */
    updateBaseSizeFilters(sliderValue) {
      // Limpar timeout anterior se existir
      if (this.filtroBaseSizeTimeout) {
        clearTimeout(this.filtroBaseSizeTimeout);
      }
      
      // Aplicar debouncing
      this.filtroBaseSizeTimeout = setTimeout(() => {
        this.aplicarFiltroBaseSizeInterno(sliderValue);
      }, 300);
    },
    
    /**
     * Previne scroll horizontal quando o slider está sendo arrastado
     */
    onSliderStart() {
      this.isSliderActive = true;
      // Prevenir scroll horizontal durante o drag apenas no container do slider
      const sliderContainer = document.querySelector('.slider-wrapper-modern');
      if (sliderContainer) {
        sliderContainer.addEventListener('wheel', this.preventScrollDuringDrag, { passive: false });
        sliderContainer.addEventListener('touchmove', this.preventScrollDuringDrag, { passive: false });
      }
    },
    
    /**
     * Restaura scroll quando o slider para de ser arrastado
     */
    onSliderEnd() {
      this.isSliderActive = false;
      // Remover listeners do container do slider
      const sliderContainer = document.querySelector('.slider-wrapper-modern');
      if (sliderContainer) {
        sliderContainer.removeEventListener('wheel', this.preventScrollDuringDrag);
        sliderContainer.removeEventListener('touchmove', this.preventScrollDuringDrag);
      }
    },
    
    /**
     * Previne scroll durante o drag do slider
     */
    preventScrollDuringDrag(event) {
      // Se o slider está ativo, prevenir scroll horizontal
      if (this.isSliderActive) {
        // Prevenir apenas scroll horizontal (deltaX)
        if (event.deltaX !== undefined && Math.abs(event.deltaX) > 0) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
        // Prevenir touchmove que cause scroll horizontal
        if (event.type === 'touchmove') {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    },
    
    /**
     * Aplica o filtro de base_size internamente
     */
    aplicarFiltroBaseSizeInterno(sliderValue) {
      if (sliderValue && Array.isArray(sliderValue) && sliderValue.length === 2) {
        // Arredondar para 1 casa decimal
        const minValue = Math.round(sliderValue[0] * 10) / 10;
        const maxValue = Math.round(sliderValue[1] * 10) / 10;
        
        // Se os valores do slider são iguais ao range completo, limpar os filtros
        if (minValue === this.baseSizeRange.min && maxValue === this.baseSizeRange.max) {
          this.filtros.baseSizeMin = null;
          this.filtros.baseSizeMax = null;
        } else {
          this.filtros.baseSizeMin = minValue;
          this.filtros.baseSizeMax = maxValue;
        }
        
        // Aplicar filtros
        this.filtrarHosts();
      }
    },
    
    /**
     * Atualiza o slider quando os campos de input mudam
     */
    updateSliderFromInput() {
      // Evitar loops infinitos verificando se os valores realmente mudaram
      const currentMin = this.baseSizeSliderValue[0];
      const currentMax = this.baseSizeSliderValue[1];
      
      // Usar valores dos campos ou valores padrão do range
      let min = this.filtros.baseSizeMin !== null && this.filtros.baseSizeMin !== undefined && this.filtros.baseSizeMin !== ''
        ? parseFloat(this.filtros.baseSizeMin) 
        : this.baseSizeRange.min;
        
      let max = this.filtros.baseSizeMax !== null && this.filtros.baseSizeMax !== undefined && this.filtros.baseSizeMax !== ''
        ? parseFloat(this.filtros.baseSizeMax) 
        : this.baseSizeRange.max;
      
      // Garantir que os valores estão dentro do range válido
      min = Math.max(this.baseSizeRange.min, Math.min(this.baseSizeRange.max, min));
      max = Math.max(this.baseSizeRange.min, Math.min(this.baseSizeRange.max, max));
      
      // Garantir que min não seja maior que max
      if (min > max) {
        [min, max] = [max, min]; // Trocar valores
        // Atualizar os campos também
        this.filtros.baseSizeMin = min;
        this.filtros.baseSizeMax = max;
      }
      
      // Arredondar para 1 casa decimal
      const validMin = Math.round(min * 10) / 10;
      const validMax = Math.round(max * 10) / 10;
      
      // Atualizar os campos com valores válidos
      this.filtros.baseSizeMin = validMin;
      this.filtros.baseSizeMax = validMax;
      
      // Só atualizar slider se os valores realmente mudaram (evita loops)
      if (currentMin !== validMin || currentMax !== validMax) {
        this.baseSizeSliderValue = [validMin, validMax];
        this.aplicarFiltroBaseSizeInterno([validMin, validMax]);
      }
    },
    
    /**
     * Formata valores de base_size para exibição
     */
    formatBaseSizeDisplay(valor) {
      if (valor === null || valor === undefined) return '0';
      const num = parseFloat(valor);
      // Se é um número inteiro, mostrar sem decimais; senão, mostrar 1 casa decimal
      return num % 1 === 0 ? num.toString() : num.toFixed(1);
    },
    
    /**
     * Parse do valor de tamanho da base (remove "GB" e converte para número)
     */
    parseSizeValue(sizeValue) {
      if (!sizeValue || sizeValue === null || sizeValue === undefined) {
        return 0;
      }
      
      let sizeNumber;
      if (typeof sizeValue === 'string') {
        // Remove espaços, "GB" e outros caracteres não numéricos, exceto ponto e vírgula
        const cleanValue = sizeValue.toString().replace(/[^\d.,]/g, '').replace(',', '.');
        sizeNumber = parseFloat(cleanValue);
      } else {
        sizeNumber = parseFloat(sizeValue);
      }
      
      return isNaN(sizeNumber) ? 0 : sizeNumber;
    },
    
    /**
     * Calcula o estilo para o highlight do range do slider
     */
    getSliderRangeStyle() {
      const min = this.filtros.baseSizeMin !== null ? this.filtros.baseSizeMin : this.baseSizeRange.min;
      const max = this.filtros.baseSizeMax !== null ? this.filtros.baseSizeMax : this.baseSizeRange.max;
      
      const total = this.baseSizeRange.max - this.baseSizeRange.min;
      const leftPercent = ((min - this.baseSizeRange.min) / total) * 100;
      const rightPercent = ((max - this.baseSizeRange.min) / total) * 100;
      
      return {
        left: leftPercent + '%',
        right: (100 - rightPercent) + '%'
      };
    },

    // Event handlers para vídeo
    onVideoLoadStart() {
      // Vídeo iniciando carregamento
    },

    onVideoLoadedMetadata() {
      // Metadados do vídeo carregados
    },

    onVideoLoadedData() {
      // Dados do vídeo carregados
    },

    onVideoCanPlay() {
      // Vídeo pode ser reproduzido
    },

    onVideoError(event) {
      console.error('[VIDEO] error - Erro no vídeo:', event);
      console.error('[VIDEO] error details:', event.target.error);
    },

    getIconeSistema(sistema) {
      switch (sistema) {
        case 'VPRA':
          return '/ico_vpra.png'
        case 'VSUC':
          return '/ico_vsuc.png'
        case 'VSUP':
          return '/ico_vsup.png'
        case 'VCON':
          return '/ico_vcon.png'
        case 'VSYN':
          return '/ico_vsyn.png'
        default:
          return '/ico_vpra.png' // ícone padrão
      }
    },

    // Método para forçar altura da tabela quando paginação mudar
    forceTableHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.calculateAvailableHeight();
        }, 100); // Pequeno delay para garantir que o DOM foi atualizado
      });
    },

    // Métodos auxiliares para gerenciar botões de atualização
    getButtonColor(sistema) {
      if (this.atualizando === sistema) {
        return 'orange'; // Cor laranja para indicar atualização em andamento
      }
      if (this.isAtualizado(sistema)) {
        return 'success';
      }
      if (this.isDatabaseSizeBlocked(sistema)) {
        return 'grey';
      }
      return '#970700'; // Cor vermelha para atualizar
    },

    isButtonDisabled(sistema) {
      // Se há alguma atualização em andamento (independente do sistema), desabilitar todos
      if (this.atualizando !== null) {
        return true;
      }
      // Se o sistema específico está sendo atualizado, desabilitar apenas ele
      if (this.atualizando === sistema) {
        return true;
      }
      // Se a base de dados está bloqueada, desabilitar
      if (this.isDatabaseSizeBlocked(sistema)) {
        return true;
      }
      return false;
    },

    getButtonIcon(sistema) {
      if (this.atualizando === sistema) {
        return 'mdi-loading'; // Ícone de loading para sistema em atualização
      }
      if (this.isAtualizado(sistema)) {
        return 'mdi-check';
      }
      if (this.isDatabaseSizeBlocked(sistema)) {
        return 'mdi-lock';
      }
      return 'mdi-update';
    },

    getButtonText(sistema) {
      if (this.atualizando === sistema) {
        return 'Atualizando...';
      }
      if (this.isAtualizado(sistema)) {
        return 'Atualizado';
      }
      if (this.isDatabaseSizeBlocked(sistema)) {
        return 'Bloqueado';
      }
      return 'Atualizar';
    },

    handleButtonClick(sistema) {
      if (this.isAtualizado(sistema)) {
        this.showSnackbar(`Sistema ${sistema} já está atualizado na versão ${this.selectedHost[`${sistema.toLowerCase()}Version`]}`, 'info');
        return;
      }
      
      if (this.isDatabaseSizeBlocked(sistema)) {
        this.showSnackbar(this.getUpdateBlockTooltip(sistema), 'warning');
        return;
      }
      
      // Se chegou até aqui, pode atualizar
      this.atualizarSistema(sistema);
    },

    // Método para limpar estado de atualização manualmente
    limparEstadoAtualizacao() {
      this.atualizando = null;
      this.showSnackbar('Estado de atualização limpo. Você pode tentar novamente.', 'info');
    },

    // Métodos para configurações de porta
    openPortaConfigDialog(host) {
      this.selectedHost = host;
      this.portaConfigForm = {
        porta_bloqueio: host.porta_bloqueio === true || host.porta_bloqueio === 'true',
        porta_liberado: host.porta_liberado === true || host.porta_liberado === 'true'
      };
      this.portaConfigDialog = true;
    },

    fecharPortaConfigDialog() {
      this.portaConfigDialog = false;
      this.selectedHost = null;
      this.portaConfigForm = {
        porta_bloqueio: false,
        porta_liberado: false
      };
    },

    async salvarPortaConfig() {
      if (!this.selectedHost) return;

      this.salvandoPortaConfig = true;
      try {
        await hostsService.updatePortaConfig(
          this.selectedHost.hostId,
          this.portaConfigForm.porta_bloqueio,
          this.portaConfigForm.porta_liberado
        );

        this.showSnackbar('Configurações de porta atualizadas com sucesso', 'success');
        
        // Atualizar o host na lista
        const idx = this.hosts.findIndex(h => h.hostId === this.selectedHost.hostId);
        if (idx !== -1) {
          this.hosts[idx].porta_bloqueio = this.portaConfigForm.porta_bloqueio;
          this.hosts[idx].porta_liberado = this.portaConfigForm.porta_liberado;
          this.filtrarHosts();
        }

        this.fecharPortaConfigDialog();
      } catch (error) {
        console.error('Erro ao salvar configurações de porta:', error);
        this.showSnackbar(
          error.response?.data?.error || error.message || 'Erro ao salvar configurações de porta',
          'error'
        );
      } finally {
        this.salvandoPortaConfig = false;
      }
    },
  }
}
</script>

<style scoped>
/* Container principal que ocupa toda a altura disponível */
.home-container {
  height: calc(100vh - 64px - 13px - 36px -10px); /* 64px para v-app-bar + 16px para padding do v-main + 36px para footer + 10px para padding do v-container */
  max-height: calc(100vh - 64px - 16px - 36px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Seção do cabeçalho - fixa no topo */
.header-section {
  flex-shrink: 0;
  background: transparent;
  z-index: 10;
}

.header-section .v-container {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

/* Seção de conteúdo - altura automática baseada no conteúdo */
.content-section {
  flex: 0 0 auto; /* Não expandir, usar altura do conteúdo */
  overflow: visible;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.content-section .v-container {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
  flex: 0 0 auto; /* Não expandir, usar altura do conteúdo */
  display: flex;
  flex-direction: column;
  overflow: visible;
}

/* Card da tabela */
.content-section .modern-card {
  flex: 0 0 auto; /* Não expandir, usar altura do conteúdo */
  display: flex;
  flex-direction: column;
  overflow: visible;
  min-height: 0;
}

/* Tabela com altura fixa para 10 registros */
.scrollable-table {
  height: auto !important;
  max-height: none !important;
  overflow: visible;
}

.scrollable-table .v-data-table__wrapper {
  height: auto !important;
  max-height: none !important;
  overflow-y: auto !important;
}

.scrollable-table .v-data-table__wrapper table {
  height: auto !important;
}

/* Garantir que o cabeçalho da tabela fique fixo */
.scrollable-table .v-data-table__wrapper table thead {
  position: sticky;
  top: 0;
  z-index: 5;
  background: inherit;
}

/* Garantir que o cabeçalho da tabela tenha fundo sólido */
.scrollable-table .v-data-table__wrapper table thead tr {
  background: inherit !important;
}

.scrollable-table .v-data-table__wrapper table thead tr th {
  background: inherit !important;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1) !important;
}

/* Melhorar a aparência do scroll */
.scrollable-table .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
}

.scrollable-table .v-data-table__wrapper::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.scrollable-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.scrollable-table .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

/* Tema escuro para scroll */
.theme-dark .scrollable-table .v-data-table__wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.theme-dark .scrollable-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
}

.theme-dark .scrollable-table .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Tema escuro para cabeçalho da tabela */
.theme-dark .scrollable-table .v-data-table__wrapper table thead tr th {
  background: inherit !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1) !important;
}

/* Garantir que a paginação seja visível */
.scrollable-table .v-data-table__footer {
  position: relative !important;
  z-index: 10 !important;
  background: inherit !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
  padding: 8px 16px !important;
  display: block !important;
  visibility: visible !important;
  height: 60px !important;
  min-height: 60px !important;
  overflow: visible !important;
}

.theme-dark .scrollable-table .v-data-table__footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* Garantir que os controles de paginação sejam visíveis */
.scrollable-table .v-data-table__footer .v-data-footer {
  background: transparent !important;
  display: flex !important;
  visibility: visible !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  height: 100% !important;
}

.scrollable-table .v-data-table__footer .v-data-footer__select {
  margin-right: 16px !important;
  display: block !important;
  visibility: visible !important;
}

.scrollable-table .v-data-table__footer .v-data-footer__pagination {
  margin-left: auto !important;
  display: flex !important;
  visibility: visible !important;
  align-items: center !important;
}

/* Forçar visibilidade dos controles de paginação */
.scrollable-table .v-data-footer__select .v-select {
  display: block !important;
  visibility: visible !important;
}

.scrollable-table .v-data-footer__pagination .v-pagination {
  display: flex !important;
  visibility: visible !important;
}

.cursor-pointer {
  cursor: pointer;
}

.v-data-table {
  background-color: transparent;
}

.v-chip {
  margin: 2px;
}

.d-flex.flex-wrap {
  gap: 4px;
}

.v-tooltip__content {
  max-width: 300px;
}

.filtros-ativos {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.v-select .v-chip {
  max-width: 120px;
}

.filter-controls {
  border-left: 3px solid #1976d2;
  padding-left: 8px;
}

.sistema-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.system-icon-container {
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.system-icon-container.updated {
  /* Sistema atualizado - borda verde vibrante com glow */
  background-color: transparent;
  border: 2px solid #00e676;
  border-radius: 50%;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 230, 118, 0.35);
}

.system-icon-container.updated .sistema-icon {
  /* Mantém cores originais para sistemas atualizados */
  filter: none;
  opacity: 1;
  border: none;
}

.system-icon-container.status-unavailable {
  background-color: rgba(158, 158, 158, 0.12);
}

.system-icon-container.status-unavailable .sistema-icon {
  filter: grayscale(100%) brightness(0.65);
  opacity: 0.5;
  border-color: #bdbdbd;
}

.system-icon-container.status-unavailable:hover .sistema-icon {
  opacity: 0.65;
  border-color: #9e9e9e;
}

.system-icon-container.status-outdated,
.system-icon-container.outdated {
  background-color: transparent;
  border: 2px solid #ff1744;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(255, 23, 68, 0.35);
  padding: 0;
}

.system-icon-container.status-outdated .sistema-icon,
.system-icon-container.outdated .sistema-icon {
  filter: none;
  opacity: 0.75;
  border: none;
  background-color: transparent;
}

.system-icon-container:hover {
  transform: scale(1.1);
}

.system-icon-container:not(.updated):not(.outdated):not(.status-outdated):hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.system-icon-container.updated:hover .sistema-icon {
  filter: brightness(1.1);
}

.system-icon-container.updated:hover {
  border-color: #00c853;
  box-shadow: 0 4px 12px rgba(0, 230, 118, 0.5);
}

.system-icon-container.status-outdated:hover .sistema-icon,
.system-icon-container.outdated:hover .sistema-icon {
  filter: brightness(1.1);
  opacity: 0.75;
}

.system-icon-container.status-outdated:hover,
.system-icon-container.outdated:hover {
  border-color: #d50000;
  box-shadow: 0 4px 12px rgba(255, 23, 68, 0.5);
}

.system-icon-container.status-blocked .sistema-icon {
  border: none;
}

.system-icon-container.status-outdated.status-blocked,
.system-icon-container.outdated.status-blocked {
  border: 2px solid #ff1744;
}

.version-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
}

.system-update-container {
  text-align: center;
}

.system-icon-container-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.sistema-icon-large {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.system-update-container .caption {
  margin-top: 8px;
}

.system-update-container .caption.success--text {
  color: #4caf50;
}

.system-update-container .caption.warning--text {
  color: #ff9800;
}

.system-update-container .caption.error--text {
  color: #f44336;
}


.system-icon-container-large.updated {
  /* Sistema atualizado - borda verde vibrante com glow */
  background-color: transparent;
  border: 4px solid #00e676;
  box-shadow: 0 4px 12px rgba(0, 230, 118, 0.35);
}

.system-icon-container-large.updated .sistema-icon-large {
  /* Mantém cores originais para sistemas atualizados */
  filter: none;
  opacity: 1;
  border: none;
}

.system-icon-container-large.outdated {
  /* Sistema desatualizado - borda vermelha vibrante */
  background-color: transparent;
  border: 4px solid #ff1744;
  box-shadow: 0 4px 12px rgba(255, 23, 68, 0.35);
}

.system-icon-container-large.outdated .sistema-icon-large {
  /* Mantém cores originais do ícone com transparência mais perceptível */
  filter: none;
  opacity: 0.6;
  border: none;
}

.system-icon-container-large:hover {
  transform: scale(1.1);
}

.system-icon-container-large:not(.updated):not(.outdated):hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.system-icon-container-large.updated:hover .sistema-icon-large {
  /* Hover para sistemas atualizados - destaque suave */
  filter: brightness(1.1);
}

.system-icon-container-large.updated:hover {
  /* Hover para sistemas atualizados - borda verde mais intensa */
  border-color: #00c853;
  box-shadow: 0 4px 12px rgba(0, 230, 118, 0.5);
}

.system-icon-container-large.outdated:hover .sistema-icon-large {
  /* Hover para sistemas desatualizados - reduzir transparência */
  filter: brightness(1.1);
  opacity: 0.75;
}

.system-icon-container-large.outdated:hover {
  /* Hover para sistemas desatualizados - borda vermelha mais intensa */
  border-color: #d50000;
  box-shadow: 0 4px 12px rgba(255, 23, 68, 0.5);
}

/* Estilos modernos para cards */
.modern-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.8) 100%);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

.modern-card-title {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 24px !important;
}

/* Tema escuro para cards */
.theme-dark .modern-card {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.9) 0%, rgba(45, 45, 45, 0.8) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.theme-dark .modern-card-title {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Tabela moderna */
.modern-table {
  border-radius: 12px !important;
  overflow: hidden;
  background: transparent !important;
}

.modern-table .v-data-table__wrapper {
  border-radius: 12px;
}

.modern-table .v-data-table__wrapper table {
  border-radius: 12px;
}

.modern-table .v-data-table__wrapper table thead tr {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.modern-table .v-data-table__wrapper table thead tr th {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  font-weight: 600;
  color: #495057;
}

.modern-table .v-data-table__wrapper table tbody tr {
  transition: all 0.2s ease;
}

.modern-table .v-data-table__wrapper table tbody tr:hover {
  background: rgba(0, 123, 255, 0.05) !important;
  transform: scale(1.01);
}

/* Tema escuro para tabela */
.table-dark .v-data-table__wrapper table thead tr {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%);
}

.table-dark .v-data-table__wrapper table thead tr th {
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.table-dark .v-data-table__wrapper table tbody tr:hover {
  background: rgba(33, 150, 243, 0.1) !important;
}

/* Diálogos modernos */
.modern-dialog .v-dialog__content {
  backdrop-filter: blur(5px);
}

.modern-dialog-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25) !important;
}

.modern-dialog-card .v-card__title {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 24px !important;
}

/* Tema escuro para diálogos */
.theme-dark .modern-dialog-card {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(45, 45, 45, 0.9) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.theme-dark .modern-dialog-card .v-card__title {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Botões modernos */
.v-btn {
  border-radius: 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px;
}

.v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.v-btn.v-btn--contained {
  background: linear-gradient(135deg, var(--v-primary-base) 0%, var(--v-primary-darken1) 100%);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

.v-btn.v-btn--contained:hover {
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4);
}

/* Campos de entrada modernos */
.v-text-field .v-input__control .v-input__slot {
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

.v-text-field .v-input__control .v-input__slot:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.v-select .v-input__control .v-input__slot {
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

.v-select .v-input__control .v-input__slot:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Manter largura fixa dos filtros mesmo com seleção */
.fixed-width-select {
  width: 100% !important;
  max-width: 100% !important;
}

.fixed-width-select .v-input__control {
  max-width: 100% !important;
}

.fixed-width-select .v-input__slot {
  max-width: 100% !important;
  overflow: hidden;
}

.fixed-width-select .v-select__selection {
  max-width: 100% !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fixed-width-select .v-chip {
  max-width: calc(100% - 20px) !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Largura fixa específica para o filtro MacroMaster */
.macro-master-filter-col {
  flex: 0 0 auto !important;
  width: auto !important;
  min-width: 200px !important;
  max-width: 200px !important;
}

.macro-master-filter-wrapper {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
}

.macro-master-select {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  flex: 0 0 200px !important;
}

.macro-master-select .v-input {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  flex: 0 0 200px !important;
}

.macro-master-select .v-input__control {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  flex: 0 0 200px !important;
}

.macro-master-select .v-input__slot {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  flex: 0 0 200px !important;
  box-sizing: border-box !important;
  position: relative !important;
}

.macro-master-select .v-select__selection {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  box-sizing: border-box !important;
}

.macro-master-select .v-select__selections {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  min-width: 0 !important;
  flex: 1 1 auto !important;
}

.macro-master-select .v-select__selection--comma {
  max-width: 100% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

/* Chips modernos */
.v-chip {
  border-radius: 20px !important;
  transition: all 0.3s ease;
  font-weight: 500;
}

.v-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Garantir cores dos chips de MacroMaster em tema claro */
.v-chip.success {
  background-color: #4caf50 !important;
  color: white !important;
}

.v-chip.error {
  background-color: #f44336 !important;
  color: white !important;
}

.v-chip.grey {
  background-color: #9e9e9e !important;
  color: white !important;
}

/* Garantir cores dos chips de MacroMaster em tema escuro */
.theme--dark .v-chip.success {
  background-color: #4caf50 !important;
  color: white !important;
}

.theme--dark .v-chip.error {
  background-color: #f44336 !important;
  color: white !important;
}

.theme--dark .v-chip.grey {
  background-color: #616161 !important;
  color: white !important;
}

/* Chip do MacroMaster - versão atualizada (mais visível) */
.macro-master-version-chip {
  font-size: 13px !important;
  height: 28px !important;
  min-width: 80px !important;
  padding: 0 12px !important;
  letter-spacing: 0.5px !important;
  font-weight: 600 !important;
}

.macro-master-version-chip .v-chip__content {
  font-size: 13px !important;
  line-height: 1.2 !important;
  padding: 0 !important;
}

/* Animações de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modern-card {
  animation: fadeInUp 0.6s ease-out;
}

/* Responsividade melhorada */
@media (max-width: 768px) {
  .modern-card-title {
    padding: 16px 20px !important;
  }
  
  .modern-dialog-card .v-card__title {
    padding: 16px 20px !important;
  }
  
  .v-btn {
    font-size: 0.875rem !important;
  }
}

/* Melhorias nos filtros */
.filter-controls {
  border-left: 3px solid var(--v-primary-base);
  padding-left: 12px;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 8px;
  margin: 8px 0;
}

.theme-dark .filter-controls {
  background: rgba(33, 150, 243, 0.1);
  border-left-color: var(--v-primary-base);
}

/* Badge de filtros ativos no topo - tema claro */
.filtros-ativos-badge {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.1) 0%, rgba(33, 150, 243, 0.15) 100%);
  border: 1px solid rgba(33, 150, 243, 0.3);
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  transition: all 0.3s ease;
}

.filtros-ativos-badge:hover {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(33, 150, 243, 0.2) 100%);
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
}

/* Badge de filtros ativos no topo - tema escuro */
.theme-dark .filtros-ativos-badge {
  background: linear-gradient(135deg, rgba(100, 181, 246, 0.1) 0%, rgba(100, 181, 246, 0.15) 100%);
  border: 1px solid rgba(100, 181, 246, 0.3);
}

.theme-dark .filtros-ativos-badge:hover {
  background: linear-gradient(135deg, rgba(100, 181, 246, 0.15) 0%, rgba(100, 181, 246, 0.2) 100%);
  box-shadow: 0 2px 8px rgba(100, 181, 246, 0.2);
}

/* Melhorias nos campos de filtro para tema escuro */
.theme-dark .v-text-field .v-input__control .v-input__slot {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.theme-dark .v-text-field .v-input__control .v-input__slot:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.theme-dark .v-select .v-input__control .v-input__slot {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.theme-dark .v-select .v-input__control .v-input__slot:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* Labels dos campos no tema escuro */
.theme-dark .v-text-field .v-label,
.theme-dark .v-select .v-label {
  color: rgba(255, 255, 255, 0.8) !important;
}

.theme-dark .v-text-field .v-label--active,
.theme-dark .v-select .v-label--active {
  color: #64b5f6 !important;
}

/* Switch no tema escuro */
.theme-dark .v-switch .v-input__slot {
  background: rgba(255, 255, 255, 0.05) !important;
}

.theme-dark .v-switch .v-label {
  color: rgba(255, 255, 255, 0.8) !important;
}

/* Alinhamento vertical do switch com os botões */
.switch-aligned {
  margin: 0 !important;
}

.switch-aligned .v-input__control {
  margin: 0 !important;
}

.switch-aligned .v-input__slot {
  margin: 0 !important;
  align-items: center !important;
}

.switch-aligned .v-input--selection-controls__input {
  margin: 0 !important;
}

/* Chips no tema escuro */
.theme-dark .v-chip {
  background: rgba(100, 181, 246, 0.2) !important;
  border-color: rgba(100, 181, 246, 0.4) !important;
  color: #64b5f6 !important;
}

.theme-dark .v-chip:hover {
  background: rgba(100, 181, 246, 0.3) !important;
  border-color: rgba(100, 181, 246, 0.6) !important;
}

/* Estilos para container dos sistemas no cronograma (usado no agendamento manual) */
.system-cronograma-container {
  min-width: 180px;
  max-width: 200px;
  padding: 16px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.system-cronograma-container:hover {
  background: rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.theme-dark .system-cronograma-container {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.theme-dark .system-cronograma-container:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.15);
}

/* Container do ícone grande para agendamento manual */
.system-icon-container-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.system-icon-container-large.active {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
  border: 2px solid #4caf50;
}

.system-icon-container-large.inactive {
  background: linear-gradient(135deg, #e0e0e0 0%, #f5f5f5 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #e0e0e0;
}

.theme-dark .system-icon-container-large.active {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
  border: 2px solid #4caf50;
}

.theme-dark .system-icon-container-large.inactive {
  background: linear-gradient(135deg, #424242 0%, #616161 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border: 2px solid #424242;
}

/* Ícone grande do sistema para agendamento manual */
.sistema-icon-large {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.system-icon-container-large.active .sistema-icon-large {
  filter: brightness(1.1) contrast(1.1);
}

.system-icon-container-large.inactive .sistema-icon-large {
  filter: grayscale(0.3) brightness(0.8);
}

/* Responsividade para agendamento manual */
@media (max-width: 768px) {
  .system-cronograma-container {
    min-width: 150px;
    max-width: 160px;
    padding: 12px;
  }
  
  .system-icon-container-large {
    width: 80px;
    height: 80px;
  }
  
  .sistema-icon-large {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 600px) {
  .system-cronograma-container {
    min-width: 120px;
    max-width: 140px;
    padding: 8px;
  }
  
  .system-icon-container-large {
    width: 70px;
    height: 70px;
  }
  
  .sistema-icon-large {
    width: 50px;
    height: 50px;
  }
}
/* Espaçamento reduzido entre elementos do filtro */
.filter-spacing {
  margin-right: 13px !important;
}
/* Filtro Cronograma sem margin-right para alinhar com "Filtrar por sistema" da linha acima */
.cronograma-filter-col {
  margin-right: 0 !important;
}
/* Filtro de tamanho base (GB) sem margin-right */
.base-size-filter-col {
  margin-right: 0 !important;
}

/* Filtro de Base Moderno - Estilo baseado no exemplo fornecido */
.base-size-filter-modern {
  width: 100%;
  padding: 8px 14px 6px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.filter-header-modern {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 12px;
}

.filter-title-modern {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  letter-spacing: 0.02em;
}

.filter-title-icon-modern {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  background: linear-gradient(135deg, #1e88ff 0%, #0041a6 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
}

.filter-range-label-modern {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  font-weight: 500;
}

.filter-body-modern {
  display: grid;
  grid-template-columns: 85px 1fr 85px;
  align-items: center;
  column-gap: 12px;
  margin-bottom: 4px;
}

.number-input-modern {
  position: relative;
  display: flex;
  align-items: center;
}

.number-input-field {
  width: 100%;
  padding: 4px 24px 4px 6px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease, background-color 150ms ease;
  appearance: textfield;
  -moz-appearance: textfield;
  height: 24px;
  line-height: 1.2;
}

.number-input-field::-webkit-outer-spin-button,
.number-input-field::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.number-input-field:focus {
  border-color: #1e88ff;
  box-shadow: 0 0 0 1px rgba(30, 136, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.08);
}

.suffix-modern {
  position: absolute;
  right: 6px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
  line-height: 1;
}

.slider-wrapper-modern {
  position: relative;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 0 2px;
}

.slider-track-modern {
  position: absolute;
  left: 2px;
  right: 2px;
  height: 3px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
}

.slider-range-modern {
  position: absolute;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(30, 136, 255, 0.4), #1e88ff);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3);
  transition: left 150ms ease, right 150ms ease;
  pointer-events: none;
}

.custom-range-slider {
  position: relative;
  z-index: 2;
}

.custom-range-slider >>> .v-slider__track {
  background: transparent !important;
  height: 3px !important;
}

.custom-range-slider >>> .v-slider__track-fill {
  background: transparent !important;
}

.custom-range-slider >>> .v-slider__thumb {
  width: 14px !important;
  height: 14px !important;
  background: #e7f0ff !important;
  border: 2px solid #1e88ff !important;
  box-shadow: 0 0 0 3px rgba(30, 136, 255, 0.25), 0 2px 4px rgba(0, 0, 0, 0.4) !important;
  transition: transform 150ms ease, box-shadow 150ms ease !important;
  touch-action: none;
  user-select: none;
}

.custom-range-slider >>> .v-slider__thumb:active {
  transform: scale(1.05) !important;
  box-shadow: 0 0 0 4px rgba(30, 136, 255, 0.35), 0 2px 8px rgba(0, 0, 0, 0.5) !important;
}

.custom-range-slider >>> .v-slider__track {
  touch-action: none;
  user-select: none;
}

/* Prevenir scroll durante drag do slider */
.custom-range-slider.v-slider--is-active {
  touch-action: none;
}

.custom-range-slider.v-slider--is-active ~ * {
  pointer-events: none;
}

.filter-footer-modern {
  display: flex;
  justify-content: space-between;
  margin-top: 2px;
  padding: 0 4px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
}

/* Ajustes para tema claro */
.theme--light .base-size-filter-modern {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.theme--light .filter-title-modern {
  color: rgba(0, 0, 0, 0.87);
}

.theme--light .filter-range-label-modern {
  color: rgba(0, 0, 0, 0.6);
}

.theme--light .number-input-field {
  background-color: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.87);
}

.theme--light .number-input-field:focus {
  background-color: rgba(0, 0, 0, 0.05);
}

.theme--light .suffix-modern {
  color: rgba(0, 0, 0, 0.5);
}

.theme--light .slider-track-modern {
  background: rgba(0, 0, 0, 0.15);
}

.theme--light .filter-footer-modern {
  color: rgba(0, 0, 0, 0.5);
}

/* Loading footer para scroll infinito */
.loading-row {
  background-color: inherit;
  opacity: 0.4;
  transition: opacity 0.3s ease;
}

.loading-row.loading-active {
  opacity: 1;
}

.loading-row td {
  background-color: inherit;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding: 30px;
  text-align: center;
}

.theme--dark .loading-row td {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

/* Flexbox para centralizar o ícone e o texto */
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  transition: color 0.3s ease;
}

.loading-row.loading-active .loader-container {
  color: rgba(0, 0, 0, 0.87);
}

.theme--dark .loader-container {
  color: rgba(255, 255, 255, 0.4);
}

.theme--dark .loading-row.loading-active .loader-container {
  color: rgba(255, 255, 255, 0.87);
}

/* O Ícone (Spinner) */
.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-left-color: #1976d2;
  border-radius: 50%;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.spinner.spinner-active {
  opacity: 1;
  animation: spin 0.8s linear infinite;
}

.theme--dark .spinner {
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-left-color: #64b5f6;
}

/* A animação de rotação */
@keyframes spin {
  to { 
    transform: rotate(360deg); 
  }
}

</style> 